import React from 'react'
import { withCookies, Cookies } from 'react-cookie'
import cookie from 'react-cookies'
import { CopyTwoTone, UploadOutlined } from '@ant-design/icons'
import {
  Form,
  Button,
  Radio,
  Switch,
  Checkbox,
  Spin,
  Table,
  Upload,
  Cascader,
  Input,
  InputNumber,
  Space,
  TimePicker,
  DatePicker as PcDatePicker,
} from 'antd'
import {
  Picker,
  List,
  Toast,
  ActionSheet,
  Drawer,
  DatePicker,
  Modal,
  TextareaItem,
} from 'antd-mobile'
import { Link } from 'react-router-dom'
import moment from 'moment'
import Zmage from 'react-zmage'
import $ from 'jquery'

import { CopyToClipboard } from 'react-copy-to-clipboard'

import styles from './form.module.css'
import ApproveDialog from './ApproveDialog'
import {
  _getDataForm,
  _approveFormData,
  _addComment,
  _getNextFlowNodes,
  _deleteComment,
  _loginByCode,
  _uploadByWx,
  _undoFormData,
  _ocrVatInvoice,
} from '../../server'
import {
  _getFormatTimeStr,
  genId,
  getWxSignature,
  isQiyeweixinApp,
  convertCurrency,
  previewFileByOW365,
  getFirstWord,
} from '../ShareUtils'
import {
  _onNumberChange,
  _setFormFieldVisibleStatus,
  _formatTDText,
  _checkChildFormInputValue,
  _randomString,
  _getDownloadPath,
  _getStatisticsValue,
  _getEquationFieldValue,
  _updateFormFieldDefaultValue,
  _formatFormField,
  _getFormatEquation,
} from '../CommonUtils'
import { SelectMember, SelectSourceData } from '../MyModals'
import { InvoiceComponent } from '../MyComs'

const ALI_OSS_DOWNLOAD = process.env.ALI_OSS_DOWNLOAD

const CheckboxGroup = Checkbox.Group
const alert = Modal.alert

const validateMessages = {
  required: '${label} is required!',
  types: {
    email: '输入的格式不正确!',
    number: '输入的格式不正确!',
  },
  number: {
    range: '${label} must be between ${min} and ${max}',
  },
}

const isIPhone = new RegExp('\\biPhone\\b|\\biPod\\b', 'i').test(
  window.navigator.userAgent
)
let wrapProps
if (isIPhone) {
  wrapProps = {
    onTouchStart: (e) => e.preventDefault(),
  }
}

class FormDetailPage extends React.Component {
  mainFormRef = React.createRef()
  childFormRef = React.createRef()

  constructor(props) {
    super(props)
    const { cookies } = this.props
    this.sid = cookies.get(process.env.TOKEN_KEY)
    this.state = {
      isLoading: true,
      tipModal: false,
      formDetailShow: false,
      profile: {},
      toaForm: {},
      formFields: [],
      currentNode: {},
      currentNodes: [],
      nextFlowNodes: [],
      transactorCC: [],
      transactor: [],
      isCreator: false,
      isTransactor: false,
      approveDialogShow: false,
      actionType: 1,
      toaDataFormLogs: [],
      processList: [],
      onlyShowComments: false,
      formLogsLength: 0,
      processPopShow: false,
      childFormDrawerOpen: false,
      commentChatShow: false,
      commentContent: '',
      commentImage: [],
      commentFile: [],
      currentFormField: { childFormFields: [] },
      preFormField: '',
      currentRow: -1,
      actionSheetOptions: [],
      selectedData: [],
      selectedExtra: {},
      atMembers: [],
      nodeExFieldList: [],
      nodeExFieldListShow: true,
      hasError: false,
      jsapiticket: '',
      timestamp: moment().format('X'),
      appId: '',
      nonceStr: genId(),
      currentUser: '',
      formDataId: '',
      code: '',
      allUserList: [],
      currentFileList: [],
      fullScreenChild: '',
      removeFileList: [],
      lastRecognizedList: [],
      formSetting: '',
    }

    if (!this.props.location.query) {
      if (window.location.search) {
        let strSearch = window.location.search
        let params = strSearch.substring(1, strSearch.length).split('&')
        if (params) {
          params.map((item, i) =>
            item.split('=')[0] === 'formDataId'
              ? (this.state.formDataId = item.split('=')[1])
              : ''
          )
          params.map((item, i) =>
            item.split('=')[0] === 'code'
              ? (this.state.code = item.split('=')[1])
              : ''
          )
        }
      }
    } else {
      this.state.formDataId = this.props.location.query.formDataId
    }

    if (!this.state.formDataId) {
      this.state.formDataId = window.sessionStorage.getItem('formDataId')
      window.sessionStorage.setItem('formDataId', '')
    }

    if (this.state.formDataId) {
      this.getDataForm()
    } else {
      this.props.history.push('/')
    }
  }

  componentDidCatch(error, info) {
    this.setState({ hasError: true })
  }

  bindRef = (ref) => {
    this.selectMemberModal = ref
  }

  bindSelectSourceDataRef = (ref) => {
    this.selectSourceDataModal = ref
  }

  settingWx() {
    // 检查是否在微信/企业微信环境中
    const ua = navigator.userAgent.toLowerCase()
    const isWxWork = ua.includes('wxwork')
    const isWeChat = ua.includes('micromessenger')
    if (!isWxWork && !isWeChat) {
      return
    }
    var appId = this.state.appId
    var timestamp = this.state.timestamp
    var nonceStr = this.state.nonceStr
    var signature = getWxSignature(
      this.state.jsapiticket,
      nonceStr,
      timestamp,
      window.location.href
    )

    if (window.wx) {
      window.wx.config({
        beta: true,
        debug: false,
        appId: appId,
        timestamp: timestamp,
        nonceStr: nonceStr,
        signature: signature,
        jsApiList: [
          'previewImage',
          'chooseImage',
          'getLocalImgData',
          'uploadImage',
        ],
      })
    }
  }

  addImageOnClick() {
    this.chooseImage()
  }

  updateSelectedData = (extra, list) => {
    switch (extra.type) {
      case 1:
        this.state.atMembers.map((item) => {
          let isHas = false
          for (var i = 0; i < list.length; i++) {
            if (list[i].userid === item.userid) {
              isHas = true
              break
            }
          }
          if (!isHas) {
            this.state.commentContent = this.state.commentContent.replace(
              '@' + item.name + ' ',
              ''
            )
          }
        })
        list.map((item) => {
          let isHas = false
          for (var i = 0; i < this.state.atMembers.length; i++) {
            if (this.state.atMembers[i].userid === item.userid) {
              isHas = true
              break
            }
          }
          if (!isHas) {
            this.state.commentContent += '@' + item.name + ' '
          }
        })
        this.setState({
          atMembers: list,
          commentContent: this.state.commentContent,
        })
        break
      default:
        break
    }
  }

  async undoFormData() {
    const res = await _undoFormData(this.sid, this.state.formDataId)
    if (res.code === 0) {
      Toast.info('撤回成功', 1)
      this.props.history.push({
        pathname: '/formmain',
        query: { formDataId: this.state.formDataId },
      })
    } else {
      Toast.offline(res.msg, 2)
      this.getDataForm()
    }
  }

  async approveFormData(
    approveDesc,
    backFlowNode,
    exFields,
    signType,
    signUsers
  ) {
    let params_signUsers = []
    if (signUsers) {
      signUsers.map((item, index) =>
        params_signUsers.splice(index, 0, item.userid)
      )
    }
    var formFields = []
    for (var i = 0; i < this.state.formFields.length; i++) {
      var item = this.state.formFields[i]
      var isEditable = item.isEditable
      if (
        item.fieldType === 'ChildField' ||
        item.fieldType === 'FORMREFCustomerField'
      ) {
        for (var j = 0; j < item.childFormFields.length; j++) {
          var subItem = item.childFormFields[j]
          var isSubEditable = subItem.isEditable
          if (subItem.fieldType === 'ChildField') {
            for (var k = 0; k < subItem.childFormFields.length; k++) {
              var sonItem = subItem.childFormFields[k]
              var isSonEditable = sonItem.isEditable
              if (isSonEditable) {
                isSubEditable = true
                formFields.splice(formFields.length, 0, {
                  fieldId: sonItem.fieldId,
                  fieldType: sonItem.fieldType,
                  formId: sonItem.formId,
                  inputValue: sonItem.inputValue,
                })
              }
            }
          }
          if (isSubEditable) {
            isEditable = true
            formFields.splice(formFields.length, 0, {
              fieldId: subItem.fieldId,
              fieldType: subItem.fieldType,
              formId: subItem.formId,
              inputValue: subItem.inputValue,
            })
          }
        }
      }
      if (isEditable) {
        formFields.splice(formFields.length, 0, {
          fieldId: item.fieldId,
          fieldType: item.fieldType,
          formId: item.formId,
          inputValue: item.inputValue,
        })
      }
    }
    const res = await _approveFormData(
      this.sid,
      this.state.formDataId,
      approveDesc,
      this.state.actionType,
      backFlowNode,
      this.state.currentNode.id,
      exFields,
      signType,
      params_signUsers,
      this.state.toaDataForm.updateTime,
      formFields
    )
    if (res.code === 0) {
      Toast.info('操作成功', 1)
      this.getDataForm()
      setTimeout(() => {
        this.props.history.push({
          pathname: '/',
          query: { selectedTab: 'handleTab' },
        })
      }, 400)
      return true
    } else {
      Toast.offline(res.msg, 2)
      return false
    }
  }

  async getDataForm() {
    const res = await _getDataForm(this.sid, this.state.formDataId)
    if (res.code === 0) {
      if (res.data.toaDataForm.status === -2) {
        this.props.history.push({
          pathname: 'formmain',
          query: { formDataId: res.data.toaDataForm.formDataId },
        })
        return
      }
      if (res.data.toaDataFormLogs) {
        res.data.toaDataFormLogs.map((item) => {
          if (item.expand) {
            item.expand = JSON.parse(item.expand)
          }
          if (item.opDesc) {
            item.opDesc = item.opDesc.replace(/</g, '&lt;')
            item.opDesc = item.opDesc.replace(/>/g, '&gt;')
          }
        })
      }

      var formSetting = ''
      if (res.data.formSetting) {
        formSetting = res.data.formSetting
      }

      this.setState({
        currentUser: res.data.userid,
        toaForm: res.data.toaForm,
        formSetting: formSetting,
        toaDataForm: res.data.toaDataForm,
        processList: res.data.processList,
        toaDataFormLogs: res.data.toaDataFormLogs,
        formLogsLength: res.data.toaDataFormLogs.length - 1,
        allUserList: res.data.allUserList,
      })
      if (res.data.isTransactor !== undefined) {
        this.setState({ isTransactor: res.data.isTransactor })
      }
      if (res.data.transactor !== undefined) {
        this.setState({ transactor: res.data.transactor })
      }
      if (res.data.transactorCC !== undefined) {
        this.setState({ transactorCC: res.data.transactorCC })
      }
      if (res.data.isCreator !== undefined) {
        this.setState({ isCreator: res.data.isCreator })
      }
      if (res.data.profile !== undefined) {
        this.setState({ profile: res.data.profile })
      }
      if (res.data.currentNodes !== undefined) {
        res.data.currentNodes.map((item) => {
          item.nodeConfig
            ? (item.nodeConfig = JSON.parse(item.nodeConfig))
            : (item.nodeConfig = {})
          item.nodePermissions
            ? (item.nodePermissions = JSON.parse(item.nodePermissions))
            : (item.nodePermissions = {})
        })

        this.setState({ currentNodes: res.data.currentNodes })
        if (res.data.currentNodes.length === 1 || !this.state.isTransactor) {
          var currentNode =
            res.data.currentNodes[res.data.currentNodes.length - 1]
          this.setState({ currentNode: currentNode })
          this.getNextFlowNodes(currentNode.id)
        }
      }

      res.data.formFields.map((item) => {
        item = _formatFormField(item)
        if (item.fieldType == 'ChildField') {
          item.childFormFields.map((subItem) => {
            subItem = _formatFormField(subItem)
            res.data.formFieldValues.map((ssItem) => {
              if (ssItem.formFieldId == subItem.fieldId && ssItem.fieldValue) {
                subItem.inputValue = JSON.parse(ssItem.fieldValue)
              }
              if (
                subItem.fieldName === '数据源' &&
                subItem.multipleValue.length === 0 &&
                subItem.inputValue.length > 0
              ) {
                subItem.multipleValue = [
                  { name: subItem.inputValue[0], isSelected: false },
                ]
              }
            })
          })
        } else if (item.fieldType == 'FORMREFCustomerField') {
          item.childFormFields.map((subItem) => {
            subItem = _formatFormField(subItem)
            if (subItem.fieldType === 'ChildField') {
              subItem.childFormFields.map((sonItem) => {
                sonItem = _formatFormField(sonItem)
              })
            }
          })
        }

        res.data.formFieldValues.map((subItem) => {
          if (subItem.formFieldId === item.fieldId && subItem.fieldValue) {
            try {
              item.inputValue = JSON.parse(subItem.fieldValue)
            } catch (err) {}
          }
          if (
            item.fieldName === '数据源' &&
            item.multipleValue.length === 0 &&
            item.inputValue.length > 0
          ) {
            item.multipleValue = [
              { name: item.inputValue[0], isSelected: false },
            ]
          }
        })
      })
      this.setState({
        formFields: this.setFormFieldVisibleStatus(res.data.formFields),
      })
      if (res.data.nodeExFieldList) {
        res.data.nodeExFieldList.map((item) => {
          item.inputValue = JSON.parse(item.fieldValue)
          if (item.multipleValue) {
            item.multipleValue = JSON.parse(item.multipleValue)
          }
        })
        this.setState({ nodeExFieldList: res.data.nodeExFieldList })
      }

      setTimeout(() => {
        let mTop
        try {
          mTop = this.titleBox.offsetHeight + 10
        } catch (err) {
          console.log(err)
          mTop = 90
        }

        this.setState({ mTop: mTop })
      }, 20)

      this.setState({
        isLoading: false,
        jsapiticket: res.data.jsapiticket,
        appId: res.data.appId,
      })
      this.settingWx()
    } else if (res.code === 3003) {
      this.setState({ tipModal: true })
    } else if (res.code === 9999) {
      cookie.remove(process.env.TOKEN_KEY, { path: '/' })
      if (this.state.code) {
        this.loginByCode()
      } else {
        this.props.history.push('/')
      }
    } else {
      Toast.offline(res.msg, 3)
      this.props.history.push('/')
    }
  }

  async loginByCode() {
    const res = await _loginByCode(this.state.code)
    if (res.code === 0) {
      const { cookies } = this.props
      cookies.set(process.env.TOKEN_KEY, res.data.sid, { path: '/' })
      this.sid = res.data.sid
      this.selectMemberModal.refresh(this.sid)
      this.getDataForm()
    } else {
      this.props.history.push('/')
    }
  }

  dropComment = (commentId) => {
    this.deleteComment(commentId)
  }

  async deleteComment(commentId) {
    const res = await _deleteComment(this.sid, commentId)
    if (res.code === 0) {
      Toast.info('操作成功', 1)
      var index = -1
      for (var i = 0; i < this.state.toaDataFormLogs.length; i++) {
        if (this.state.toaDataFormLogs[i].id === commentId) {
          index = i
          break
        }
      }
      if (index >= 0) {
        this.state.toaDataFormLogs.splice(index, 1)
        this.setState({ toaDataFormLogs: this.state.toaDataFormLogs })
      }
    } else {
      Toast.offline(res.msg, 2)
    }
  }

  setFormFieldVisibleStatus = (formFieldList) => {
    var nodePermissions = this.state.currentNode.nodePermissions
    if (!nodePermissions) {
      nodePermissions = {}
    }

    return _setFormFieldVisibleStatus(
      formFieldList,
      nodePermissions,
      2,
      this.state.toaDataForm.status,
      this.state.isTransactor
    )
  }

  async getNextFlowNodes(currentNodeId) {
    const res = await _getNextFlowNodes(
      this.sid,
      this.state.formDataId,
      currentNodeId
    )
    if (res.code === 0) {
      this.setState({ nextFlowNodes: res.data.tFlowNodeList })
    }
  }

  async addComment() {
    var userList = []
    this.state.atMembers.map((item, index) =>
      userList.splice(index, 0, item.userid)
    )
    const res = await _addComment(
      this.sid,
      this.state.commentContent,
      this.state.formDataId,
      userList,
      this.state.commentImage,
      this.state.commentFile
    )
    if (res.code === 0) {
      Toast.info('评论成功', 1)
      if (res.data.toaDataFormLogs) {
        res.data.toaDataFormLogs.map((item) => {
          if (item.expand) {
            item.expand = JSON.parse(item.expand)
          }
          if (item.opDesc) {
            item.opDesc = item.opDesc.replace(/</g, '&lt;')
            item.opDesc = item.opDesc.replace(/>/g, '&gt;')
          }
        })
      }
      this.setState({
        toaDataFormLogs: res.data.toaDataFormLogs,
        atMembers: [],
        commentContent: '',
        commentImage: [],
        commentFile: [],
      })
      return true
    } else {
      Toast.offline(res.msg + '，请稍后重试', 3)
    }

    return false
  }

  formDetailToggle = () => {
    this.setState({ formDetailShow: !this.state.formDetailShow })
  }

  approveSubmit = async (
    actionDesc,
    backFlowNode,
    exFields,
    signType,
    signUsers
  ) => {
    const result = await this.approveFormData(
      actionDesc,
      backFlowNode,
      exFields,
      signType,
      signUsers
    )
    return result
  }

  randomFlag = ''
  onDrawerOpenChange = () => {
    this.randomFlag = _randomString(6)
    if (this.state.preFormField) {
      var tmpFormField = this.state.preFormField
      this.setState({ preFormField: '', currentFormField: tmpFormField })
      return
    }
    if (this.state.childFormDrawerOpen) {
      if (this.state.currentFormField.preInputValue) {
        this.state.currentFormField.preInputValue = []
      }
    }
    this.state.currentFormField.childFormFields.map((item) => {
      item.editing = -1
    })

    this.setState({ childFormDrawerOpen: !this.state.childFormDrawerOpen })
  }

  showChatBox = () => {
    this.setState({ commentChatShow: !this.state.commentChatShow })
  }

  closeChatBox = () => {
    this.setState({ commentChatShow: !this.state.commentChatShow })
  }

  saveChildFormBack = () => {
    if (this.saveChildForm()) {
      this.onDrawerOpenChange()
    }
  }

  saveChildForm = () => {
    let dataObj = this.state.currentFormField.inputValue[this.state.currentRow]
    if (undefined == dataObj) {
      dataObj = {}
    }
    dataObj = _checkChildFormInputValue(
      dataObj,
      this.state.currentFormField.childFormFields
    )
    if (!dataObj) {
      return false
    }
    let formFieldValue = this.state.currentFormField.inputValue
    if (this.state.currentRow === -1) {
      dataObj.key = formFieldValue.length + 1
    }

    dataObj.example = false
    this.state.currentRow === -1
      ? this.state.currentFormField.inputValue.splice(
          formFieldValue.length,
          0,
          dataObj
        )
      : this.state.currentFormField.inputValue.splice(
          this.state.currentRow,
          1,
          dataObj
        )

    this.state.formFields.map((item) => {
      if (item.fieldType === 'StatisticsField') {
        var moreSetting = item.moreSetting
        if (
          moreSetting &&
          moreSetting.statistics &&
          moreSetting.statistics.values &&
          moreSetting.statistics.values.length >= 2
        ) {
          if (
            this.state.currentFormField.fieldId ==
            moreSetting.statistics.values[0]
          ) {
            item.inputValue = [
              _getStatisticsValue(item, this.state.currentFormField),
            ]
            this.updateFormField(item)
          }
        }
      } else if (item.fieldType === 'FORMREFCustomerField') {
        item.childFormFields.map((subItem) => {
          if (subItem.fieldType === 'StatisticsField') {
            var moreSetting = subItem.moreSetting
            if (
              moreSetting &&
              moreSetting.statistics &&
              moreSetting.statistics.values &&
              moreSetting.statistics.values.length >= 2
            ) {
              if (
                this.state.currentFormField.fieldId ==
                moreSetting.statistics.values[0]
              ) {
                subItem.inputValue = [
                  _getStatisticsValue(subItem, this.state.currentFormField),
                ]
                this.updateFormField(subItem)
              }
            }
          }
        })
      }
    })

    this.updateFormField(this.state.currentFormField)

    return true
  }

  submitComment = () => {
    if (
      this.state.commentContent.length === 0 &&
      this.state.commentImage.length === 0 &&
      this.state.commentFile.length === 0
    ) {
      return
    }
    if (this.addComment()) {
      this.setState({
        commentChatShow: !this.state.commentChatShow,
        commentFile: [],
        commentImage: [],
      })
    }
  }

  onCommentImageUpload = (info) => {
    if (info.file.response && info.file.response.code === 0) {
      info.file.url = info.file.response.data.fileUrl
      var imageList = []
      info.fileList.map((item) => {
        if (!item.url && item.response && item.response.data) {
          item.url = item.response.data.fileUrl
        }
        if (item.url) {
          imageList.push(item)
        }
      })
      Toast.info('上传成功', 1)
      this.setState({ commentImage: imageList })
    } else if (info.file.response && info.file.response.code !== 0) {
      Toast.info('上传失败，请重试', 1)
    }
  }

  getThumbUrl(data) {
    var fileType = data.type
    if (fileType === 'application/pdf') {
      return require('../../assets/img/pdf.png')
    } else if (
      fileType ===
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document' ||
      fileType === 'application/msword'
    ) {
      return require('../../assets/img/doc.png')
    } else if (
      fileType ===
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    ) {
      return require('../../assets/img/sheet.png')
    } else if (
      fileType ===
      'application/vnd.openxmlformats-officedocument.presentationml.presentation'
    ) {
      return require('../../assets/img/ppt.png')
    } else if (fileType.indexOf('image/') === 0) {
      return ALI_OSS_DOWNLOAD + data.url
    } else {
      return require('../../assets/img/unknow.png')
    }
  }

  onCommentFileUpload = (info) => {
    this.setState({ currentFileList: [...info.fileList] })
    if (info.file.response) {
      var fileList = []
      info.fileList.map((item) => {
        if (!item.url && item.response && item.response.data) {
          item.url = item.response.data.fileUrl
        }
        if (item.url) {
          fileList.push(item)
        }
      })
      if (info.file.response.code === 0) {
        Toast.info('上传成功', 1)
      } else if (info.file.response.code !== 0) {
        Toast.info('上传失败，请重试', 1)
      }
      this.setState({ commentFile: fileList, currentFileList: fileList })
    }
  }

  renderChildFormDetail = () => {
    var isChildFormEdit = false
    var formFields = this.state.currentFormField.childFormFields
    for (let index = 0; index < formFields.length; index++) {
      const element = formFields[index]
      if (element.isEditable) {
        isChildFormEdit = true
        break
      }
      if (element.fieldType === 'ChildField') {
        for (
          let subIndex = 0;
          subIndex < element.childFormFields.length;
          subIndex++
        ) {
          const subElement = element.childFormFields[subIndex]
          if (subElement.isEditable) {
            isChildFormEdit = true
            break
          }
        }
        if (isChildFormEdit) {
          break
        }
      }
    }
    return (
      <div
        className={styles.childFormContainer}
        style={{
          width: document.documentElement.clientWidth,
          maxWidth: this.state.fullScreenChild ? 'unset' : 600,
        }}
      >
        <Form
          className={styles.formContent}
          validateMessages={validateMessages}
          ref={this.childFormRef}
        >
          {this.state.currentFormField.childFormFields.map((item) =>
            item.isVisible ? (
              <div className={styles.formGroup} key={item.fieldId}>
                <div
                  className={styles.formLabel}
                  style={{ padding: '10px 0 10px' }}
                >
                  {item.fieldType !== 'SectionBreak' ? (
                    <label className={styles.controlLabel}>
                      {item.fieldTitle}
                      {item.fieldType != 'StaffField' &&
                      item.fieldType != 'ChildField' &&
                      item.fieldType != 'AccessoryField' &&
                      item.fieldType != 'FORMREFCustomerField' &&
                      item.fieldType != 'OcrInvoice' &&
                      item.fieldType != 'ImageField' ? (
                        <CopyToClipboard
                          text={
                            item.inputValue.length > 0 ? item.inputValue[0] : ''
                          }
                          onCopy={() => {
                            Toast.info(item.fieldTitle + '值复制成功', 1)
                          }}
                        >
                          <CopyTwoTone
                            style={{ fontSize: 18, padding: '0px 10px' }}
                          />
                        </CopyToClipboard>
                      ) : (
                        <div></div>
                      )}
                    </label>
                  ) : (
                    ''
                  )}
                </div>
                <div className={styles.fieldContent}>
                  <div
                    className={
                      this.state.fullScreenChild === item.fieldId
                        ? `${styles.childFormFullScreen}`
                        : ``
                    }
                  >
                    {this.renderFormField(item)}
                  </div>
                </div>
                <div className={styles.helpBlock}></div>
              </div>
            ) : (
              ''
            )
          )}
        </Form>
        <div className={styles.childFormFootctrl}>
          {isChildFormEdit ? (
            <div style={{ display: 'flex', width: '100%' }}>
              <Button
                style={{ flex: 1, height: 44, marginRight: 15 }}
                onClick={() => {
                  if (this.state.currentFormField.preInputValue) {
                    this.state.currentFormField.inputValue = JSON.parse(
                      JSON.stringify(this.state.currentFormField.preInputValue)
                    )
                    this.updateFormField(this.state.currentFormField)
                  }
                  this.onDrawerOpenChange()
                }}
              >
                取消
              </Button>
              <Button
                style={{ flex: 1, height: 44, marginRight: 15 }}
                onClick={this.saveChildFormBack}
              >
                保存
              </Button>
            </div>
          ) : (
            <div style={{ display: 'flex', width: '100%' }}>
              <Button
                style={{ flex: 1, height: 44 }}
                onClick={this.onDrawerOpenChange}
              >
                返回
              </Button>
            </div>
          )}
        </div>
      </div>
    )
  }

  renderFormStatus() {
    if (this.state.toaDataForm) {
      switch (this.state.toaDataForm.status) {
        case 0:
          return (
            <span
              className={[
                `${styles.applyStatus}`,
                `${styles.active}`,
                `${styles.statusRed}`,
              ].join(' ')}
            >
              退审
            </span>
          )
        case 1:
          return (
            <span
              className={[
                `${styles.applyStatus}`,
                `${styles.active}`,
                `${styles.statusGreen}`,
              ].join(' ')}
            >
              已审批
            </span>
          )
        case 2:
          return (
            <span
              className={[
                `${styles.applyStatus}`,
                `${styles.active}`,
                `${styles.statusBlue}`,
              ].join(' ')}
            >
              审批中
            </span>
          )
        case -1:
          return (
            <span
              className={[
                `${styles.applyStatus}`,
                `${styles.active}`,
                `${styles.statusGray}`,
              ].join(' ')}
            >
              已关闭
            </span>
          )
        case 99:
          return (
            <span
              className={[
                `${styles.applyStatus}`,
                `${styles.active}`,
                `${styles.statusGray}`,
              ].join(' ')}
            >
              已关闭
            </span>
          )
        default:
          return ''
      }
    } else {
      return ''
    }
  }

  showActionSheet = () => {
    let actionSheetOptions = ['评论']
    if (this.state.isTransactor || this.state.isCreator) {
      if (this.state.currentNode.nodeConfig) {
        if (this.state.currentNode.nodeConfig.isFinish) {
          actionSheetOptions.splice(actionSheetOptions.length, 0, '结束流程')
        }
        if (this.state.currentNode.nodeConfig.isClose) {
          actionSheetOptions.splice(actionSheetOptions.length, 0, '关闭')
        }
        if (this.state.currentNode.nodeConfig.isRecall) {
          actionSheetOptions.splice(actionSheetOptions.length, 0, '撤回')
        }
      }
    }
    actionSheetOptions.splice(actionSheetOptions.length, 0, '流转明细')
    actionSheetOptions.splice(actionSheetOptions.length, 0, '取消')

    this.setState({ actionSheetOptions })
    ActionSheet.showActionSheetWithOptions(
      {
        options: actionSheetOptions,
        cancelButtonIndex: actionSheetOptions.length - 1,
        maskClosable: true,
        wrapProps,
      },
      (buttonIndex, rowIndex) => {
        switch (this.state.actionSheetOptions[buttonIndex]) {
          case '评论':
            this.showChatBox()
            break
          case '结束流程':
            break
          case '关闭':
            this.setState({
              actionType: 0,
              approveDialogShow: !this.state.approveDialogShow,
            })
            break
          case '撤回':
            this.undoFormData()
            break
          case '流转明细':
            this.setState({ processPopShow: !this.state.processPopShow })
            break
          default:
            break
        }
      }
    )
  }

  chooseImage = () => {
    window.wx.chooseImage({
      count: 9,
      sizeType: ['original', 'compressed'],
      sourceType: ['album', 'camera'],
      defaultCameraMode: 'batch',
      isSaveToAlbum: 1,
      success: (res) => {
        var localIds = res.localIds
        if (localIds) {
          for (var i = 0; i < localIds.length; i++) {
            var item = localIds[i]
            window.wx.uploadImage({
              localId: item,
              isShowProgressTips: 1,
              success: (res) => {
                var serverIds = [res.serverId]
                this.uploadByWx(serverIds)
              },
            })
          }
        }
      },
    })
  }

  previewImage = (list, data) => {
    var urls = []
    if (list && list.length > 0) {
      list.map((item) => {
        urls.push(process.env.API_HOST + _getDownloadPath(item.url, item.name))
      })
    } else {
      urls.push(process.env.API_HOST + _getDownloadPath(data.url, data.name))
    }
    window.wx.previewImage({
      current: process.env.API_HOST + _getDownloadPath(data.url, data.name),
      urls: urls,
    })
  }

  async uploadByWx(serverIds) {
    const res = await _uploadByWx(this.sid, serverIds)
    if (res.code === 0) {
      var imageList = []
      if (res.data.values) {
        res.data.values.map((item) => {
          imageList.push(item)
        })
      }
      this.setState({ commentImage: imageList })
    }
  }

  onNumberChange = (value, data) => {
    // if (!value || typeof (value) !== 'number') {
    //     return;
    // }
    data = _onNumberChange(value, data)
    this.updateFormField(data)
  }

  onCommonChange = (e, data) => {
    data.inputValue = [e.target.value]
    this.updateFormField(data)
  }

  onPickerChange = (e, data) => {
    data.inputValue = e
    this.updateFormField(data)
  }

  onCheckBoxChange = (checkedList, data) => {
    if (data.maxLength > 0 && checkedList.length > data.maxLength) {
      Toast.info('最多选' + data.maxLength + '个', 1)
      return
    }
    data.inputValue = checkedList
    this.updateFormField(data)
  }

  onTextAreaChange = (value, data) => {
    if (value) {
      var reg =
        /<!--\[if\s+gte\s+mso\s+\d+\]>(?:(?!<!\[endif\]-->)[\s\S])*<!\[endif\]-->/
      value = value.replace(reg, '')
    }
    data.inputValue = [value, value]
    this.updateFormField(data)
  }

  onUploadChange = (info, data) => {
    if (info.file.response && info.file.response.code === 0) {
      info.file.url = info.file.response.data.fileUrl
      var fileList = []
      info.fileList.map((item) => {
        if (!item.url && item.response && item.response.data) {
          item.url = item.response.data.fileUrl
        }
        if (item.type.indexOf('image/') === 0) {
          item.thumbUrl = item.url
        }
        if (item.url) {
          fileList.push(item)
        }
      })
      data.inputValue = fileList
      this.updateFormField(data)
    }
  }

  mergeFileList = (list) => {
    const removedUrls = this.state.removeFileList || []
    const map = new Map()

    list.forEach((file) => {
      const key = file.uid || file.url

      if (file.url && removedUrls.includes(file.url)) {
        return
      }

      if (!map.has(key)) {
        map.set(key, file)
        return
      }

      const old = map.get(key)

      // done 覆盖 uploading
      if (old.status !== 'done' && file.status === 'done') {
        map.set(key, file)
      }
    })

    return Array.from(map.values())
  }

  onOcrVatInvoiceChange = async (info, data) => {
    if (!info) return

    let fileList = info.fileList.map((f) => {
      // 上传完成时修正 url
      if (f.status === 'done' && !f.url) {
        if (f.response && f.response.data) {
          f.url = f.response.data.fileUrl
        }
      }
      return f
    })

    // ========== 在判断是否全部上传完成之前排除 removeFileList ==========
    const removedUrls = this.state.removeFileList || []
    fileList = fileList.filter((f) => !removedUrls.includes(f.url))

    // ----------- 判断是否全部上传完成 -------------------
    const allDone = fileList.every((f) => f.status === 'done')

    // 更新 inputValue
    data.inputValue = this.mergeFileList([...data.inputValue, ...info.fileList])
    this.updateFormField(data)

    // ---------- 如果没全部完成，不识别 ----------
    if (!allDone) return

    // ---------- 全部完成，再统一识别 ----------
    const newFileUrls = fileList.map((f) => f.url)
    let newFiles = newFileUrls.filter((f) => {
      return this.state.lastRecognizedList.indexOf(f) < 0
    })

    if (newFiles.length > 0) {
      await this.ocrVatInvoice(newFiles, data)
      // 更新 lastRecognizedList
      this.setState({
        lastRecognizedList: [
          ...new Set(this.state.lastRecognizedList.concat(newFiles)),
        ],
      })
    }

    if (data.inputValue) {
      for (let index = data.inputValue.length - 1; index >= 0; index--) {
        const element = data.inputValue[index]
        if (element.status === 'done') {
          var isHas = false
          for (let i = 0; i < fileList.length; i++) {
            const ele = fileList[i]
            if (ele.url && ele.url === element.url) {
              isHas = true
              break
            }
          }
          if (!isHas) {
            fileList.unshift(element)
          }
        }
      }
    }

    data.inputValue = this.mergeFileList([...data.inputValue, ...info.fileList])
    this.updateFormField(data)
  }

  async ocrVatInvoice(fileUrlList, data) {
    if (fileUrlList) {
      var newFileUrlList = []
      for (let index = 0; index < fileUrlList.length; index++) {
        const thumbUrl = fileUrlList[index]
        var isAppend = true
        data.inputValue.map((item) => {
          if (item.invoiceInfo && item.invoiceInfo.words_result_num > 0) {
            if (item.thumbUrl === thumbUrl) {
              isAppend = false
            }
          }
        })
        if (isAppend) {
          newFileUrlList.push(thumbUrl)
        }
      }

      Toast.info('正在识别' + newFileUrlList.length + '张发票...', 300)
      const res = await _ocrVatInvoice(this.sid, newFileUrlList)
      if (res.code === 0) {
        var successNum = 0
        var tErrorNum = 0
        var newInputValue = []
        for (var i = 0; i < data.inputValue.length; i++) {
          data.inputValue[i].ocrStatus = true
          if (data.inputValue[i].url && res.data[data.inputValue[i].url]) {
            var invoiceInfo = JSON.parse(res.data[data.inputValue[i].url])
            if (invoiceInfo.TErrorMsg) {
              if (
                this.state.removeFileList.indexOf(data.inputValue[i].url) < 0
              ) {
                this.state.removeFileList.push(data.inputValue[i].url)
                this.setState({ removeFileList: this.state.removeFileList })
              }
              tErrorNum++
              successNum++
              newInputValue.push(data.inputValue[i])
              continue
            } else {
              var isHas = false
              for (let j = 0; j < data.inputValue.length; j++) {
                const element = data.inputValue[j]
                if (element.invoiceInfo) {
                  let ekey = 'InvoiceNum'
                  const etype =
                    getFirstWord(element.invoiceInfo, 'result_type', '') ||
                    element.invoiceInfo.result_type
                  if (etype === 'vat_invoice') {
                    ekey = 'InvoiceNum'
                  } else if (etype === 'air_ticket') {
                    ekey = 'invoice_num'
                  } else if (etype === 'taxi_receipt') {
                    ekey = 'InvoiceNum'
                  } else if (etype === 'train_ticket') {
                    ekey = 'invoice_num'
                  } else if (etype === 'quota_invoice') {
                    ekey = 'invoice_number'
                  } else if (etype === 'printed_invoice') {
                    ekey = 'InvoiceNum'
                  } else if (etype === 'roll_normal_invoice') {
                    ekey = 'InvoiceNum'
                  } else if (etype === 'motor_vehicle_invoice') {
                    ekey = 'fapiao-haoma'
                  } else if (etype === 'used_vehicle_invoice') {
                    ekey = 'invoice_num'
                  }
                  const eInvoiceNum = getFirstWord(
                    element.invoiceInfo,
                    ekey,
                    ''
                  )
                  let vkey = 'InvoiceNum'
                  const vtype =
                    getFirstWord(invoiceInfo, 'result_type', '') ||
                    invoiceInfo.result_type
                  if (vtype === 'vat_invoice') {
                    vkey = 'InvoiceNum'
                  } else if (vtype === 'air_ticket') {
                    vkey = 'invoice_num'
                  } else if (vtype === 'taxi_receipt') {
                    vkey = 'InvoiceNum'
                  } else if (vtype === 'train_ticket') {
                    vkey = 'invoice_num'
                  } else if (vtype === 'quota_invoice') {
                    vkey = 'invoice_number'
                  } else if (vtype === 'printed_invoice') {
                    vkey = 'InvoiceNum'
                  } else if (vtype === 'roll_normal_invoice') {
                    vkey = 'InvoiceNum'
                  } else if (vtype === 'motor_vehicle_invoice') {
                    vkey = 'fapiao-haoma'
                  } else if (vtype === 'used_vehicle_invoice') {
                    vkey = 'invoice_num'
                  }
                  const vInvoiceNum = getFirstWord(invoiceInfo, vkey, '')
                  if (eInvoiceNum == vInvoiceNum) {
                    isHas = true
                    break
                  }
                }
              }
              if (isHas) {
                if (
                  this.state.removeFileList.indexOf(data.inputValue[i].url) < 0
                ) {
                  this.state.removeFileList.push(data.inputValue[i].url)
                  this.setState({ removeFileList: this.state.removeFileList })
                }
                tErrorNum++
                successNum++
                newInputValue.push(data.inputValue[i])
                continue
              }

              successNum++
              data.inputValue[i].invoiceInfo = invoiceInfo
            }
          }
          newInputValue.push(data.inputValue[i])
        }
        data.inputValue = JSON.parse(JSON.stringify(newInputValue))
        if (successNum > 0) {
          Toast.info('成功识别' + successNum + '张发票', 2)
        }
        if (tErrorNum > 0) {
          setTimeout(() => {
            Toast.info(tErrorNum + '张发票重复，已禁止上传', 3)
          }, 2000)
        }

        this.updateFormField(data)
      } else {
        Toast.info('识别失败，请重试', 1)
      }
    }
  }

  updateFormField = (data) => {
    for (let index = 0; index < this.state.formFields.length; index++) {
      var element = this.state.formFields[index]
      if (element.fieldId === data.fieldId) {
        element = data
        break
      }
      if (
        element.fieldType === 'ChildField' ||
        element.fieldType === 'FORMREFCustomerField'
      ) {
        var isHas = false
        for (
          let subIndex = 0;
          subIndex < element.childFormFields.length;
          subIndex++
        ) {
          var subElement = element.childFormFields[subIndex]
          if (subElement.fieldId === data.fieldId) {
            subElement = data
            isHas = true
            break
          }
        }
        if (isHas) {
          element.childFormFields = this.setFormFieldVisibleStatus(
            element.childFormFields
          )
          break
        }
      }
    }

    this.state.formFields.map((item) => {
      if (item.fieldType === 'EquationField') {
        item.inputValue = [_getEquationFieldValue(item, this.state.formFields)]
        this.mainFormRef.current.setFieldsValue({
          [item.fieldId]: item.inputValue[0],
        })
      } else if (
        item.fieldType === 'ChildField' ||
        item.fieldType === 'FORMREFCustomerField'
      ) {
        item.childFormFields.map((subItem) => {
          if (subItem.fieldType === 'EquationField') {
            subItem.inputValue = [
              _getEquationFieldValue(subItem, this.state.formFields),
            ]
            var formItemName = subItem.fieldId
            if (this.state.currentRow !== -1) {
              formItemName +=
                '_' + this.randomFlag + '_' + this.state.currentRow
            }
            this.childFormRef.current.setFieldsValue({
              [formItemName]: subItem.inputValue[0],
            })
          } else if (subItem.fieldType === 'ChildField') {
            subItem.childFormFields.map((sonItem) => {
              if (sonItem.fieldType === 'EquationField') {
                sonItem.inputValue = [
                  _getEquationFieldValue(sonItem, this.state.formFields),
                ]
                var formItemName = sonItem.fieldId
                if (this.state.currentRow !== -1) {
                  formItemName +=
                    '_' + this.randomFlag + '_' + this.state.currentRow
                }
                this.childFormRef.current.setFieldsValue({
                  [formItemName]: sonItem.inputValue[0],
                })
              }
            })
            subItem.childFormFields = this.setFormFieldVisibleStatus(
              subItem.childFormFields
            )
          }
        })
        item.childFormFields = this.setFormFieldVisibleStatus(
          item.childFormFields
        )
      }
    })

    this.state.formFields.map((item) => {
      if (
        item.defaultValueType == 4 &&
        item.defaultValue &&
        item.fieldId !== data.fieldId
      ) {
        item = _updateFormFieldDefaultValue(item, this.state.formFields)
        this.mainFormRef.current.setFieldsValue({
          [item.fieldId]: item.inputValue[0],
        })
      }
      if (
        item.fieldType === 'ChildField' ||
        item.fieldType === 'FORMREFCustomerField'
      ) {
        item.childFormFields.map((subItem) => {
          if (subItem.fieldType === 'ChildField') {
            subItem.childFormFields.map((sonItem) => {
              if (
                sonItem.defaultValueType == 4 &&
                sonItem.defaultValue &&
                sonItem.fieldId !== data.fieldId
              ) {
                sonItem = _updateFormFieldDefaultValue(
                  sonItem,
                  this.state.formFields
                )
                var formItemName = sonItem.fieldId
                if (this.state.currentRow !== -1) {
                  formItemName +=
                    '_' + this.randomFlag + '_' + this.state.currentRow
                }
                this.childFormRef.current.setFieldsValue({
                  [formItemName]: sonItem.inputValue[0],
                })
              }
            })
          } else {
            if (
              subItem.defaultValueType == 4 &&
              subItem.defaultValue &&
              subItem.fieldId !== data.fieldId
            ) {
              subItem = _updateFormFieldDefaultValue(
                subItem,
                this.state.formFields
              )
              var formItemName = subItem.fieldId
              if (this.state.currentRow !== -1) {
                formItemName +=
                  '_' + this.randomFlag + '_' + this.state.currentRow
              }
              this.childFormRef.current.setFieldsValue({
                [formItemName]: subItem.inputValue[0],
              })
            }
          }
        })
        item.childFormFields = this.setFormFieldVisibleStatus(
          item.childFormFields
        )
      }
    })

    this.state.formFields = this.setFormFieldVisibleStatus(
      this.state.formFields
    )
    this.setState({ formFields: this.state.formFields })
  }

  renderFormField(data) {
    var initialValue =
      data.inputValue.length > 0 ? (initialValue = data.inputValue[0]) : ''
    var formItemName = data.fieldId
    if (this.state.currentRow !== -1) {
      formItemName += '_' + this.randomFlag + '_' + this.state.currentRow
    }
    const inputNumberView = (
      <span>
        <div className={[`${styles.geoField}`, `${styles.readOnly}`].join(' ')}>
          <p className={styles.textFieldP}>{data.inputValue[0]}</p>
        </div>
        {data.isCapital ? (
          <div className={styles.inputExtra}>
            大写金额（人民币）：{convertCurrency(data.inputValue[0])}
          </div>
        ) : (
          ''
        )}
      </span>
    )
    switch (data.fieldType) {
      case 'MobileField':
        if (data.isEditable) {
          return (
            <Form.Item
              name={[formItemName]}
              initialValue={initialValue}
              rules={[
                {
                  pattern: new RegExp(
                    '^[1](([3][0-9])|([4][5-9])|([5][0-3,5-9])|([6][5,6])|([7][0-8])|([8][0-9])|([9][1,8,9]))[0-9]{8}',
                    'g'
                  ),
                  message: '输入的格式不正确',
                },
              ]}
            >
              <Input
                id={'input_' + data.fieldId}
                maxLength={11}
                className={[`${styles.textField}`, ``].join(' ')}
                onBlur={(e) => {
                  window.scrollTo(0, 0)
                  this.onCommonChange(e, data)
                }}
              />
            </Form.Item>
          )
        }
        return (
          <div
            className={[`${styles.geoField}`, `${styles.readOnly}`].join(' ')}
          >
            <p className={styles.textFieldP}>{data.inputValue[0]}</p>
          </div>
        )
      case 'NumberField':
        if (data.isEditable) {
          var precision = ''
          if (
            data.moreSetting &&
            undefined != data.moreSetting.decimalPoint &&
            data.moreSetting.decimalPoint != -1
          ) {
            if (initialValue && initialValue != 0) {
              precision = data.moreSetting.decimalPoint
            }
          }

          if (precision != '') {
            return (
              <Form.Item
                name={[formItemName]}
                initialValue={initialValue}
                rules={[{ type: 'number' }]}
                extra={
                  data.isCapital ? (
                    <div>
                      大写金额（人民币）：{convertCurrency(initialValue)}
                    </div>
                  ) : (
                    ''
                  )
                }
              >
                <InputNumber
                  onBlur={() => window.scrollTo(0, 0)}
                  id={'input_' + data.fieldId}
                  precision={precision}
                  readOnly={data.isReadOnly}
                  className={[
                    `${styles.textField}`,
                    data.isReadOnly ? `${styles.readOnly}` : ``,
                  ].join(' ')}
                  style={{ overflowX: 'hidden' }}
                  onChange={(value) => this.onNumberChange(value, data)}
                  onStep={(e) => {
                    const v = e.target.value
                    if (v !== undefined && v !== '') {
                      const fixed = Number(v).toFixed(precision)
                      this.onNumberChange(Number(fixed), data)
                    }
                  }}
                  parser={(value) => {
                    if (value) {
                      if (value.indexOf('.') === -1) {
                        return value
                      } else {
                        var parts = value.split('.')
                        var IntegerNum = parts[0]
                        if (data.moreSetting.decimalPoint === 0) {
                          return IntegerNum
                        } else {
                          var DecimalNum = parts[1].substr(
                            0,
                            data.moreSetting.decimalPoint
                          )
                          return IntegerNum + '.' + DecimalNum
                        }
                      }
                    }
                  }}
                />
              </Form.Item>
            )
          } else {
            return (
              <Form.Item
                name={[formItemName]}
                initialValue={initialValue}
                rules={[{ type: 'number' }]}
                extra={
                  data.isCapital ? (
                    <div>
                      大写金额（人民币）：{convertCurrency(initialValue)}
                    </div>
                  ) : (
                    ''
                  )
                }
              >
                <InputNumber
                  onBlur={() => window.scrollTo(0, 0)}
                  id={'input_' + data.fieldId}
                  readOnly={data.isReadOnly}
                  style={{ overflowX: 'hidden' }}
                  className={[
                    `${styles.textField}`,
                    data.isReadOnly ? `${styles.readOnly}` : ``,
                  ].join(' ')}
                  onChange={(value) => this.onNumberChange(value, data)}
                />
              </Form.Item>
            )
          }
        }

        return (
          <div
            className={[`${styles.geoField}`, `${styles.readOnly}`].join(' ')}
          >
            <p className={styles.textFieldP}>{initialValue}</p>
            {data.isCapital ? (
              <div className={styles.inputExtra}>
                大写金额（人民币）：{convertCurrency(initialValue)}
              </div>
            ) : (
              ''
            )}
          </div>
        )
      case 'EmailField':
        if (data.isEditable) {
          return (
            <Form.Item
              name={[formItemName]}
              initialValue={initialValue}
              rules={[{ type: 'email', message: '输入的格式不正确' }]}
            >
              <Input
                id={'input_' + data.fieldId}
                className={[
                  `${styles.textField}`,
                  data.isReadOnly ? `${styles.readOnly}` : ``,
                ].join(' ')}
                onBlur={(e) => {
                  window.scrollTo(0, 0)
                  this.onCommonChange(e, data)
                }}
              />
            </Form.Item>
          )
        }
        return (
          <div
            className={[`${styles.geoField}`, `${styles.readOnly}`].join(' ')}
          >
            <p className={styles.textFieldP}>{data.inputValue[0]}</p>
          </div>
        )
      case 'TextField':
        if (data.isEditable) {
          return (
            <input
              onBlur={() => window.scrollTo(0, 0)}
              type="text"
              id={'input_' + data.fieldId}
              maxLength="2000"
              className={[`${styles.textField}`, ``].join(' ')}
              value={data.inputValue[0]}
              onChange={(e) => this.onCommonChange(e, data)}
            />
          )
        }
        return (
          <div
            className={[`${styles.geoField}`, `${styles.readOnly}`].join(' ')}
          >
            <p className={styles.textFieldP}>{data.inputValue[0]}</p>
          </div>
        )
      case 'TextArea':
        if (data.isEditable) {
          var initialValue = ''
          if (data.inputValue.length > 0) {
            initialValue = data.inputValue[0]
          }
          return (
            <div className={styles.textareaField}>
              {
                <TextareaItem
                  onBlur={() => window.scrollTo(0, 0)}
                  id={'input_' + data.fieldId}
                  rows={4}
                  defaultValue={initialValue}
                  onChange={(value) => this.onTextAreaChange(value, data)}
                ></TextareaItem>
              }
            </div>
          )
        }
        if (data.inputValue.length >= 1) {
          data.inputValue[0] = data.inputValue[0].replace(
            /(\r\n|\n|\r)/gm,
            '<br>'
          )
        }
        return (
          <div
            className={[`${styles.textareaField}`, `${styles.readOnly}`].join(
              ' '
            )}
          >
            <div
              style={{ overflowX: 'auto' }}
              contentEditable="false"
              dangerouslySetInnerHTML={{ __html: data.inputValue[0] }}
              className={styles.textareaDivEdit}
            ></div>
          </div>
        )
      case 'RadioButton':
        if (data.isEditable) {
          if (
            data.moreSetting &&
            data.moreSetting.dataSourceUrl &&
            data.moreSetting.isFullScreen
          ) {
            var reqParams = []
            for (var i = 0; i < this.state.formFields.length; i++) {
              var item = this.state.formFields[i]
              if (
                data.moreSetting.dataSourceUrl.indexOf(
                  '${' + item.fieldId + '}'
                ) > 0
              ) {
                reqParams.push(item)
              }
            }
            var valueStr = ''
            if (data.inputValue) {
              for (var i = 0; i < data.inputValue.length; i++) {
                valueStr += data.inputValue[i]
                if (i < data.inputValue.length - 1) {
                  valueStr += ', '
                }
              }
            }
            return (
              <div
                onBlur={() => window.scrollTo(0, 0)}
                onClick={() => {
                  this.setState(
                    {
                      selectedData: data.inputValue,
                      selectedExtra: {
                        type: 200,
                        data,
                        maxLength: data.maxLength,
                        formId: this.state.toaForm.formId,
                        fieldId: data.fieldId,
                        reqParams: reqParams,
                      },
                    },
                    () => setTimeout(this.selectSourceDataModal.showModal(), 20)
                  )
                }}
                className={[`${styles.textField}`, `${styles.readOnly}`].join(
                  ' '
                )}
                style={{
                  height: 'auto',
                  minHeight: '40px',
                  wordBreak: 'break-all',
                  overflow: 'hidden',
                }}
              >
                {valueStr}
              </div>
            )
          }
          return (
            <Radio.Group
              value={data.inputValue[0]}
              className={[
                `${styles.choiceField}`,
                data.isReadOnly ? `${styles.readOnly}` : ``,
              ].join(' ')}
              onChange={(e) => this.onCommonChange(e, data)}
            >
              {data.multipleValue.map((item, index) => (
                <div
                  key={index}
                  className={styles.choiceFieldItem}
                  style={{ width: 100 / data.showType + '%' }}
                >
                  <Radio
                    value={item.name}
                    style={{
                      display: 'block',
                      width: '100%',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'normal',
                      wordWrap: 'break-word',
                    }}
                  >
                    {item.name}
                  </Radio>
                </div>
              ))}
            </Radio.Group>
          )
        }
        if (data.moreSetting && data.moreSetting.dataSourceUrl) {
          var valueStr = ''
          if (data.inputValue[0]) {
            valueStr = data.inputValue[0]
          }
          return (
            <div
              onBlur={() => window.scrollTo(0, 0)}
              className={[`${styles.textField}`, `${styles.readOnly}`].join(
                ' '
              )}
              style={{
                height: 'auto',
                minHeight: '40px',
                wordBreak: 'break-all',
                overflow: 'hidden',
              }}
            >
              {valueStr}
            </div>
          )
        }
        return (
          <Radio.Group
            disabled={true}
            value={data.inputValue[0]}
            className={[`${styles.choiceField}`, `${styles.readOnly}`].join(
              ' '
            )}
          >
            {data.multipleValue.map((item, index) => (
              <div
                key={index}
                className={styles.choiceFieldItem}
                style={{ width: 100 / data.showType + '%' }}
              >
                <Radio
                  value={item.name}
                  defaultChecked={index == 1}
                  style={{
                    display: 'block',
                    width: '100%',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'normal',
                    wordWrap: 'break-word',
                  }}
                >
                  {item.name}
                </Radio>
              </div>
            ))}
          </Radio.Group>
        )
      case 'DropDown':
        const dropDownData = []
        data.multipleValue.map((item, index) => {
          dropDownData.splice(index, 0, { label: item.name, value: item.name })
        })
        if (data.isEditable) {
          return (
            <Picker
              data={dropDownData}
              extra={data.tip}
              cols={1}
              onChange={(e) => this.onPickerChange(e, data)}
              value={data.inputValue}
            >
              <List.Item
                arrow="horizontal"
                style={{ border: '1px solid #e5e5e5', borderRadius: 4 }}
              >
                {data.fieldTitle}
              </List.Item>
            </Picker>
          )
        }
        return (
          <Picker
            disabled={true}
            data={dropDownData}
            extra={data.tip}
            cols={1}
            value={data.inputValue}
            className={styles.readOnly}
          >
            <List.Item
              className={styles.readOnly}
              arrow="horizontal"
              style={{ border: '1px solid #e5e5e5', borderRadius: 4 }}
            >
              {data.fieldTitle}
            </List.Item>
          </Picker>
        )
      case 'CheckBox':
        const checkboxData = []
        data.multipleValue.map((item, index) => {
          checkboxData.splice(index, 0, item.name)
        })
        if (data.isEditable) {
          return (
            <CheckboxGroup
              value={data.inputValue}
              onChange={(e) => this.onCheckBoxChange(e, data)}
              className={[
                `${styles.choiceField}`,
                data.isReadOnly ? `${styles.readOnly}` : ``,
              ].join(' ')}
            >
              {checkboxData.map((item, index) => (
                <div
                  key={index}
                  className={styles.choiceFieldItem}
                  style={{ width: 100 / data.showType + '%' }}
                >
                  <Checkbox
                    key={item}
                    value={item}
                    style={{
                      display: 'block',
                      width: '100%',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'normal',
                      wordWrap: 'break-word',
                    }}
                  >
                    {item}
                  </Checkbox>
                </div>
              ))}
            </CheckboxGroup>
          )
        }
        return (
          <CheckboxGroup
            disabled={true}
            value={data.inputValue}
            className={[`${styles.choiceField}`, `${styles.readOnly}`].join(
              ' '
            )}
          >
            {checkboxData.map((item, index) => (
              <div
                key={index}
                className={styles.choiceFieldItem}
                style={{ width: 100 / data.showType + '%' }}
              >
                <Checkbox
                  style={{
                    whiteSpace: 'normal',
                    wordWrap: 'break-word',
                    display: 'block',
                  }}
                  value={item}
                >
                  {item}
                </Checkbox>
              </div>
            ))}
          </CheckboxGroup>
        )
      case 'SectionBreak':
        return (
          <div>
            <div className={styles.sectionField}></div>
            <div className={styles.sectionFieldLabel}>{data.fieldTitle}</div>
          </div>
        )
      case 'DateField':
        if (data.isEditable) {
          var value = new Date()
          if (data.inputValue[0]) {
            value = new Date(data.inputValue[0])
            valueStr = moment(data.inputValue[0]).format('YYYY-MM-DD')
          }

          return (
            <span>
              {isQiyeweixinApp() ? (
                <DatePicker
                  format
                  mode="date"
                  value={value}
                  onChange={(date) => {
                    data.inputValue = [date.getTime()]
                    this.updateFormField(data)
                  }}
                >
                  <Input
                    type="text"
                    readOnly
                    className={styles.textField}
                    value={valueStr}
                    style={{ overflowX: 'unset' }}
                    allowClear
                    onChange={() => {
                      data.inputValue = []
                      this.updateFormField(data)
                    }}
                  />
                </DatePicker>
              ) : (
                <Space direction="vertical" style={{ width: '100%' }}>
                  <PcDatePicker
                    style={{ overflowX: 'hidden' }}
                    format="YYYY-MM-DD"
                    className={styles.textField}
                    defaultValue={moment(data.inputValue[0])}
                    onChange={(date, dateString) => {
                      data.inputValue = [moment(date).valueOf()]
                      this.updateFormField(data)
                    }}
                    getPopupContainer={(triggerNode) => triggerNode.parentNode}
                  />
                </Space>
              )}
            </span>
          )
        }
        var valueStr = ''
        if (data.inputValue && data.inputValue.length && data.inputValue[0]) {
          valueStr = moment(data.inputValue[0]).format('YYYY-MM-DD')
        }
        return (
          <input
            type="text"
            readOnly
            className={[`${styles.textField}`, `${styles.readOnly}`].join(' ')}
            value={valueStr}
          />
        )
      case 'TimeField':
        if (data.isEditable) {
          var value = new Date()
          if (data.inputValue[0]) {
            value = new Date(data.inputValue[0])
            valueStr = moment(data.inputValue[0]).format('HH:mm')
          }
          return (
            <span>
              {isQiyeweixinApp() ? (
                <DatePicker
                  format
                  mode="time"
                  value={value}
                  onChange={(date) => {
                    data.inputValue = [date.getTime()]
                    this.updateFormField(data)
                  }}
                >
                  <Input
                    type="text"
                    readOnly
                    className={styles.textField}
                    value={valueStr}
                    style={{ overflowX: 'unset' }}
                    allowClear
                    onChange={() => {
                      data.inputValue = []
                      this.updateFormField(data)
                    }}
                  />
                </DatePicker>
              ) : (
                <TimePicker
                  style={{ overflowX: 'hidden' }}
                  className={styles.textField}
                  defaultValue={valueStr ? moment(valueStr, 'HH:mm') : ''}
                  getPopupContainer={(triggerNode) => triggerNode.parentNode}
                  onChange={(date, timeString) => {
                    data.inputValue = [moment(date).valueOf()]
                    this.updateFormField(data)
                  }}
                  format="HH:mm"
                />
              )}
            </span>
          )
        }
        var valueStr = ''
        if (data.inputValue && data.inputValue.length && data.inputValue[0]) {
          valueStr = moment(data.inputValue[0]).format('HH:mm')
        }
        return (
          <input
            type="text"
            readOnly
            className={[`${styles.textField}`, `${styles.readOnly}`].join(' ')}
            value={valueStr}
          />
        )
      case 'DateTimeField':
        if (data.isEditable) {
          var value = new Date()
          if (data.inputValue[0]) {
            value = new Date(data.inputValue[0])
            valueStr = moment(data.inputValue[0]).format('YYYY-MM-DD HH:mm')
          }
          return (
            <span>
              {isQiyeweixinApp() ? (
                <DatePicker
                  format
                  mode="datetime"
                  value={value}
                  onChange={(date) => {
                    data.inputValue = [date.getTime()]
                    this.updateFormField(data)
                  }}
                >
                  <Input
                    type="text"
                    readOnly
                    className={styles.textField}
                    value={valueStr}
                    style={{ overflowX: 'unset' }}
                    allowClear
                    onChange={() => {
                      data.inputValue = []
                      this.updateFormField(data)
                    }}
                  />
                </DatePicker>
              ) : (
                <Space direction="vertical" style={{ width: '100%' }}>
                  <PcDatePicker
                    showTime
                    style={{ overflowX: 'hidden' }}
                    format="YYYY-MM-DD HH:mm"
                    className={styles.textField}
                    defaultValue={moment(data.inputValue[0])}
                    onChange={(date, dateString) => {
                      data.inputValue = [moment(date).valueOf()]
                      this.updateFormField(data)
                    }}
                    getPopupContainer={(triggerNode) => triggerNode.parentNode}
                  />
                </Space>
              )}
            </span>
          )
        }
        var valueStr = ''
        if (data.inputValue && data.inputValue.length && data.inputValue[0]) {
          valueStr = moment(data.inputValue[0]).format('YYYY-MM-DD HH:mm')
        }
        return (
          <input
            type="text"
            readOnly
            className={[`${styles.textField}`, `${styles.readOnly}`].join(' ')}
            value={valueStr}
          />
        )
      case 'StaffField':
        if (data.isEditable) {
          return (
            <div>
              {data.inputValue.length > 0 ? (
                <div className={styles.relativeField}>
                  {data.inputValue.map((item, index) => (
                    <div key={index} className={styles.relativeList}>
                      <span className={styles.relativeListItemIcon}></span>
                      {item.name}
                    </div>
                  ))}
                </div>
              ) : (
                ''
              )}
              <div
                className={styles.childFormItemAdd}
                onClick={(e) => {
                  e.preventDefault()
                  this.setState(
                    {
                      selectedData: data.inputValue,
                      selectedExtra: {
                        type: 2,
                        data,
                        maxLength: data.maxLength,
                      },
                    },
                    () => setTimeout(this.selectMemberModal.showModal(), 20)
                  )
                }}
              >
                点击添加
              </div>
            </div>
          )
        }
        return (
          <div>
            {data.inputValue.length > 0 ? (
              <div className={styles.relativeField}>
                {data.inputValue.map((item, index) => (
                  <div key={index} className={styles.relativeList}>
                    <span className={styles.relativeListItemIcon}></span>
                    {item.name}
                  </div>
                ))}
              </div>
            ) : (
              ''
            )}
          </div>
        )
      case 'ChildField':
        var myDataSource = []
        if (data.inputValue.length == 0) {
          data.inputValue = [{ id: 1, key: 1, example: true }]
        } else {
          data.inputValue.map((item, index) => (item.id = index + 1))
        }

        myDataSource = JSON.parse(JSON.stringify(data.inputValue))
        for (var i = 0; i < myDataSource.length; i++) {
          for (var val in myDataSource[i]) {
            if (
              myDataSource[i][val] instanceof Array &&
              myDataSource[i][val].length > 0
            ) {
              for (var j = 0; j < myDataSource[i][val].length; j++) {
                if (
                  myDataSource[i][val][j] &&
                  !(myDataSource[i][val][j] instanceof String) &&
                  myDataSource[i][val][j].name
                ) {
                  myDataSource[i][val][j] = myDataSource[i][val][j].name + ', '
                }
              }
            }
          }
        }

        let columns = [
          {
            title: (
              <span
                onClick={() => {
                  var element = $('.am-drawer-sidebar')
                  if (this.state.fullScreenChild == data.fieldId) {
                    this.setState({ fullScreenChild: '' })
                    element.css('left', '')
                    element.css('top', '')
                    element.css('position', '')
                  } else {
                    element.css('left', 0)
                    element.css('top', 0)
                    element.css('position', 'fixed')
                    this.setState({ fullScreenChild: data.fieldId })
                  }
                }}
                className={
                  this.state.fullScreenChild == data.fieldId
                    ? [
                        `${styles.icon_btn}`,
                        `${styles.ic_child_fullScreen}`,
                      ].join(' ')
                    : [`${styles.icon_btn}`, `${styles.ic_child_normal}`].join(
                        ' '
                      )
                }
              ></span>
            ),
            width: 60,
            dataIndex: 'id',
            key: 'id',
            fixed: 'left',
            align: 'center',
            id: 1,
          },
        ]

        var width = 200
        if (data.childFormFields.length <= 2) {
          width = (100 % data.childFormFields.length) + '%'
        }
        if (this.state.fullScreenChild == data.fieldId) {
          width = 'auto'
        }

        data.childFormFields.map((item, i) => {
          let column = {
            title: item.fieldTitle,
            dataIndex: item.fieldId,
            key: item.fieldId,
            ellipsis: !(this.state.fullScreenChild == data.fieldId),
            width: i !== data.childFormFields.length - 1 ? width : '',
            onCell: (record, index) => {
              return {
                onClick: (event) => {
                  data.childFormFields.map((subItem) => {
                    subItem.inputValue = []
                    if (data.inputValue.length > 0) {
                      var valueObj = data.inputValue[index]
                      if (valueObj[subItem.fieldId]) {
                        subItem.inputValue = valueObj[subItem.fieldId]
                      }
                      if (
                        valueObj['multipleValue'] &&
                        valueObj['multipleValue'][subItem.fieldId]
                      ) {
                        subItem.multipleValue =
                          valueObj['multipleValue'][subItem.fieldId]
                      }
                    }
                  })
                  data.childFormFields = this.setFormFieldVisibleStatus(
                    data.childFormFields
                  )

                  if (
                    item.isEditable != false &&
                    (item.fieldType === 'TextField' ||
                      item.fieldType === 'NumberField' ||
                      item.fieldType === 'EmailField' ||
                      item.fieldType === 'MobileField')
                  ) {
                    item.editing = index
                    this.updateFormField(data)
                  } else {
                    data.preInputValue = JSON.parse(
                      JSON.stringify(data.inputValue)
                    )
                    if (
                      !this.state.currentFormField ||
                      (this.state.currentFormField &&
                        this.state.currentFormField.fieldType !==
                          'FORMREFCustomerField')
                    ) {
                      this.setState(
                        {
                          currentRow: index,
                          currentFormField: data,
                          fullScreenChild: '',
                          preFormField: '',
                        },
                        () => {
                          this.onDrawerOpenChange()
                        }
                      )
                    } else {
                      var tmpFormField = this.state.currentFormField
                      this.setState({
                        currentRow: index,
                        currentFormField: data,
                        preFormField: tmpFormField,
                      })
                    }
                  }
                },
                onMouseEnter: (event) => {},
              }
            },
            render: (text, record, index) => {
              if (text && item.fieldType === 'TextArea') {
                var inputValue = record[item.fieldId]
                if (inputValue.length > 1) {
                  text = inputValue[0]
                }
              } else if (
                text &&
                typeof text === 'number' &&
                (item.fieldType === 'EquationField' ||
                  item.fieldType === 'StatisticsField' ||
                  item.fieldType === 'NumberField')
              ) {
                if (
                  item.moreSetting &&
                  undefined != item.moreSetting.decimalPoint &&
                  item.moreSetting.decimalPoint != -1
                ) {
                  text = parseFloat(text + '').toFixed(
                    item.moreSetting.decimalPoint
                  )
                }
                if (item.isCapital) {
                  text =
                    text + '<br>大写金额（人民币）：' + convertCurrency(text)
                }
              } else if (
                text &&
                (item.fieldType === 'CascadeDropDown' ||
                  item.fieldType === 'CUSTOMIZE_RadioButton')
              ) {
                if (text.length > 1) {
                  var textTmp = ''
                  for (var i = 0; i < text.length; i++) {
                    textTmp += text[i]
                    if (i < text.length - 1) {
                      textTmp += '/'
                    }
                  }
                  text = textTmp
                }
              }
              if (!text) {
                text = ''
              }
              if (
                item.isEditable != false &&
                (item.fieldType === 'TextField' ||
                  item.fieldType === 'NumberField' ||
                  item.fieldType === 'EmailField' ||
                  item.fieldType === 'MobileField')
              ) {
                if (item.editing === index) {
                  return (
                    <Form.Item style={{ margin: '-3px' }}>
                      <Input
                        defaultValue={text}
                        type={
                          item.fieldType === 'NumberField' ? 'number' : 'text'
                        }
                        onPressEnter={(e) => {
                          item.editing = -1
                          this.updateFormField(data)
                        }}
                        onChange={(e) => {
                          if (item.fieldType === 'NumberField') {
                            var newItem = _onNumberChange(e.target.value, item)
                            if (newItem && newItem.inputValue) {
                              data.inputValue[index][item.fieldId] =
                                newItem.inputValue
                            }
                          } else {
                            data.inputValue[index][item.fieldId] = [
                              e.target.value,
                            ]
                          }

                          data.childFormFields.map((subItem) => {
                            if (
                              subItem.fieldType === 'EquationField' &&
                              subItem.moreSetting &&
                              subItem.moreSetting.equation
                            ) {
                              var value = 0
                              try {
                                var equation = _getFormatEquation(
                                  subItem.moreSetting.equation
                                )
                                data.childFormFields.map((sonItem) => {
                                  if (
                                    equation.indexOf(
                                      '${' + sonItem.fieldId + '}'
                                    ) >= 0
                                  ) {
                                    var fieldValue =
                                      data.inputValue[index][sonItem.fieldId]
                                    if (fieldValue != undefined) {
                                      equation = equation.replace(
                                        new RegExp(
                                          '\\${' + sonItem.fieldId + '}',
                                          'g'
                                        ),
                                        '(' + parseFloat(fieldValue) + ')'
                                      )
                                    }
                                  }
                                })
                                if (equation.indexOf('/(0)') > 0) {
                                  equation = equation.replace(
                                    /\/\(0\)/g,
                                    '/(1)'
                                  )
                                }
                                if (equation.indexOf('*(0)') > 0) {
                                  equation = equation.replace(
                                    /\*\(0\)/g,
                                    '*(1)'
                                  )
                                }
                                value = eval(equation)
                                if (isNaN(value)) {
                                  value = undefined
                                }
                              } catch (err) {
                                value = undefined
                              }
                              if (value != undefined) {
                                if (
                                  subItem.moreSetting &&
                                  undefined !=
                                    subItem.moreSetting.decimalPoint &&
                                  subItem.moreSetting.decimalPoint != -1
                                ) {
                                  value = value.toFixed(
                                    subItem.moreSetting.decimalPoint
                                  )
                                }

                                if (value == '0.00' || value == '0.0') {
                                  value = 0
                                }
                                data.inputValue[index][subItem.fieldId] = [
                                  value,
                                ]
                              }
                            }
                          })
                          data.childFormFields.map((subItem) => {
                            if (
                              subItem.defaultValueType == 4 &&
                              subItem.defaultValue &&
                              item.fieldId != subItem.fieldId
                            ) {
                              data.inputValue[index][subItem.fieldId] =
                                data.inputValue[index][
                                  subItem.defaultValue.substring(
                                    2,
                                    subItem.defaultValue.length - 1
                                  )
                                ]
                            }
                          })
                          this.updateFormField(data)
                        }}
                      />
                    </Form.Item>
                  )
                } else {
                  return (
                    <div
                      contentEditable={false}
                      dangerouslySetInnerHTML={{ __html: text }}
                    ></div>
                  )
                }
              } else {
                return (
                  <div
                    contentEditable={false}
                    dangerouslySetInnerHTML={{ __html: text }}
                  ></div>
                )
              }
            },
          }
          columns.splice(columns.length, 0, column)
        })

        return (
          <div className={styles.childFormTable}>
            <Table
              bordered
              pagination={false}
              size="middle"
              columns={columns}
              dataSource={myDataSource}
              scroll={{ x: true }}
            />
          </div>
        )
      case 'AccessoryField':
        if (data.isEditable) {
          return (
            <Upload
              multiple="true"
              action={process.env.API_HOST + '/file/upload.api'}
              onChange={(info) => this.onUploadChange(info, data)}
              data={{ authtoken: this.sid }}
              defaultFileList={data.inputValue}
              onDownload={(file) => {
                const url =
                  process.env.API_HOST + _getDownloadPath(file.url, file.name)
                const link = document.createElement('a')
                link.href = url
                link.download = file.name
                link.click()
              }}
              onPreview={(file) => {
                if (file && file.type && file.type.indexOf('image/') === 0) {
                  Zmage.browsing({
                    src: ALI_OSS_DOWNLOAD + file.url,
                    backdrop: 'rgba(0,0,0,.5)',
                  })
                } else {
                  previewFileByOW365(file)
                }
              }}
            >
              <Button>
                <UploadOutlined />
              </Button>
            </Upload>
          )
        }
        return (
          <Upload
            showUploadList={{
              showRemoveIcon: false,
              showDownloadIcon: true,
              downloadIcon: '下载文件',
            }}
            onRemove={() => {
              return false
            }}
            defaultFileList={data.inputValue}
            onDownload={(file) => {
              const url =
                process.env.API_HOST + _getDownloadPath(file.url, file.name)
              const link = document.createElement('a')
              link.href = url
              link.download = file.name
              link.click()
            }}
            onPreview={(file) => {
              if (file && file.type && file.type.indexOf('image/') === 0) {
                Zmage.browsing({
                  src: ALI_OSS_DOWNLOAD + file.url,
                  backdrop: 'rgba(0,0,0,.5)',
                })
              } else {
                previewFileByOW365(file)
              }
            }}
          ></Upload>
        )
      case 'BusinessField':
        const businessData = []
        data.multipleValue.map((item, index) => {
          businessData.splice(index, 0, item.name)
        })
        if (data.isEditable) {
          return (
            <div
              className={[
                `${styles.choiceField}`,
                data.isReadOnly ? `${styles.readOnly}` : ``,
              ].join(' ')}
            >
              <CheckboxGroup
                value={data.inputValue}
                onChange={(e) => this.onCheckBoxChange(e, data)}
              >
                {businessData.map((item, index) => (
                  <Checkbox
                    className={styles.choiceFieldItem}
                    key={item}
                    value={item}
                    style={{ width: '50%' }}
                  >
                    {item}
                  </Checkbox>
                ))}
              </CheckboxGroup>
            </div>
          )
        }
        return (
          <div
            className={[`${styles.choiceField}`, `${styles.readOnly}`].join(
              ' '
            )}
          >
            <CheckboxGroup disabled={true} value={data.inputValue}>
              {businessData.map((item, index) => (
                <Checkbox
                  className={styles.choiceFieldItem}
                  key={item}
                  value={item}
                  style={{ width: '50%' }}
                >
                  {item}
                </Checkbox>
              ))}
            </CheckboxGroup>
          </div>
        )
      case 'CascadeDropDown':
        if (data.isEditable) {
          return (
            <div style={{ display: 'flex' }}>
              <Cascader
                style={{ flex: '1 1', position: 'relative' }}
                options={data.multipleValue}
                value={data.inputValue}
                onChange={(value) => {
                  data.inputValue = value
                  this.updateFormField(data)
                }}
                placeholder="请选择"
              />
            </div>
          )
        }
        return (
          <div
            className={[`${styles.choiceField}`, `${styles.readOnly}`].join(
              ' '
            )}
          >
            <Cascader
              style={{ width: '100%' }}
              disabled={true}
              options={data.multipleValue}
              defaultValue={data.inputValue}
              placeholder="请选择"
            />
          </div>
        )
      case 'EquationField':
        return inputNumberView
      case 'StatisticsField':
        return inputNumberView
      case 'ImageField':
        return (
          <ul className={styles.impression}>
            {data.inputValue.map((item) => {
              return (
                <li className={styles.imageList}>
                  <p className={styles.img}>
                    {isQiyeweixinApp() ? (
                      <img
                        className={[
                          `${styles.image_addIcon}`,
                          `${styles.previewImagesField}`,
                        ].join(' ')}
                        src={
                          process.env.API_HOST +
                          _getDownloadPath(item.url, item.name)
                        }
                        onClick={() => this.previewImage(data.inputValue, item)}
                      ></img>
                    ) : (
                      <Zmage
                        src={ALI_OSS_DOWNLOAD + item.url}
                        backdrop="rgba(0,0,0,.5)"
                        className={[
                          `${styles.image_addIcon}`,
                          `${styles.previewImagesField}`,
                        ].join(' ')}
                      ></Zmage>
                    )}
                  </p>
                </li>
              )
            })}
          </ul>
        )
      case 'OcrInvoice':
        return (
          <span>
            <ul className={styles.impression}>
              {data.inputValue.map((item) => {
                return (
                  <li
                    className={styles.imageList}
                    style={{ borderBottom: 'none', marginTop: '4px' }}
                  >
                    <p className={styles.img}>
                      {typeof item.url === 'string' &&
                      item.url.toLowerCase().endsWith('.pdf') ? (
                        <span>
                          <img
                            className={[
                              `${styles.image_addIcon}`,
                              `${styles.previewImagesField}`,
                            ].join(' ')}
                            src={require('../../assets/img/pdf.png')}
                            onClick={() => previewFileByOW365(item)}
                          />
                        </span>
                      ) : isQiyeweixinApp() ? (
                        <img
                          className={[
                            `${styles.image_addIcon}`,
                            `${styles.previewImagesField}`,
                          ].join(' ')}
                          src={
                            process.env.API_HOST +
                            _getDownloadPath(item.url, item.name)
                          }
                          onClick={() =>
                            this.previewImage(data.inputValue, item)
                          }
                        ></img>
                      ) : (
                        <Zmage
                          src={ALI_OSS_DOWNLOAD + item.url}
                          backdrop="rgba(0,0,0,.5)"
                          className={[
                            `${styles.image_addIcon}`,
                            `${styles.previewImagesField}`,
                          ].join(' ')}
                        ></Zmage>
                      )}
                    </p>
                  </li>
                )
              })}
              {data.isEditable ? (
                <span>
                  <Upload
                    multiple="true"
                    action={process.env.API_HOST + '/file/upload.api'}
                    onChange={(info) => this.onOcrVatInvoiceChange(info, data)}
                    accept="image/*,.pdf"
                    data={{ authtoken: this.sid }}
                    showUploadList={false}
                  >
                    <div className={styles.add_image_box}>
                      <div
                        className={[
                          `${styles.image_addIcon}`,
                          `${styles.disabled}`,
                        ].join(' ')}
                      ></div>
                    </div>
                  </Upload>
                </span>
              ) : (
                <span></span>
              )}
            </ul>
            {data.inputValue.map((item, index) => {
              return (
                <InvoiceComponent
                  index={index}
                  invoiceInfo={item.invoiceInfo}
                ></InvoiceComponent>
              )
            })}
          </span>
        )
      case 'FORMREFCustomerField':
        var myDataSource = []
        let cols = [
          {
            title: (
              <span
                onClick={() => {
                  if (this.state.fullScreenChild == data.fieldId) {
                    this.setState({ fullScreenChild: '' })
                  } else {
                    this.setState({ fullScreenChild: data.fieldId })
                  }
                }}
                className={
                  this.state.fullScreenChild == data.fieldId
                    ? [
                        `${styles.icon_btn}`,
                        `${styles.ic_child_fullScreen}`,
                      ].join(' ')
                    : [`${styles.icon_btn}`, `${styles.ic_child_normal}`].join(
                        ' '
                      )
                }
              ></span>
            ),
            width: 60,
            dataIndex: 'id',
            key: 'id',
            fixed: 'left',
            align: 'center',
            id: 1,
          },
        ]

        for (var i = 0; i < data.inputValue.length; i++) {
          if (data.inputValue[i].fieldList) {
            data.inputValue[i].fieldList.id = i + 1
            myDataSource.push(data.inputValue[i].fieldList)
          }
        }

        var width = 200
        if (data.childFormFields.length <= 2) {
          width = (100 % data.childFormFields.length) + '%'
        }

        data.childFormFields.map((item, i) => {
          let column = {
            title: item.fieldTitle,
            dataIndex: item.fieldId,
            key: item.fieldId,
            ellipsis: !(this.state.fullScreenChild == data.fieldId),
            width: i !== data.childFormFields.length - 1 ? width : '',
            render: (text, record, index) => {
              text = _formatTDText(text, item, record)
              return (
                <div
                  style={{ overflowX: 'auto' }}
                  contentEditable={false}
                  dangerouslySetInnerHTML={{ __html: text }}
                ></div>
              )
            },
          }
          cols.splice(cols.length, 0, column)
        })

        return (
          <div>
            {data.inputValue.length > 0 ? (
              <div>
                <div className={styles.childFormTable}>
                  <Table
                    bordered
                    pagination={false}
                    size="middle"
                    columns={cols}
                    dataSource={myDataSource}
                    scroll={{ x: true }}
                    onRow={(record, index) => {
                      return {
                        onClick: (event) => {
                          data.childFormFields.map((item) => {
                            item.inputValue = ['']
                            if (data.inputValue.length > 0) {
                              var valueObj = data.inputValue[index].fieldList
                              if (valueObj[item.fieldId]) {
                                item.inputValue = valueObj[item.fieldId]
                              }
                              if (
                                valueObj['multipleValue'] &&
                                valueObj['multipleValue'][item.fieldId]
                              ) {
                                item.multipleValue =
                                  valueObj['multipleValue'][item.fieldId]
                              }
                            }
                          })
                          data.childFormFields = this.setFormFieldVisibleStatus(
                            data.childFormFields
                          )
                          data.preInputValue = JSON.parse(
                            JSON.stringify(data.inputValue)
                          )
                          this.setState(
                            { currentRow: index, currentFormField: data },
                            () => {
                              this.onDrawerOpenChange()
                            }
                          )
                        },
                      }
                    }}
                  />
                </div>
              </div>
            ) : (
              ''
            )}
          </div>
        )
      case 'CUSTOMIZE_RadioButton':
        if (data.isCascadeDropDown) {
          return (
            <div
              className={[`${styles.choiceField}`, `${styles.readOnly}`].join(
                ' '
              )}
            >
              <Cascader
                style={{ width: '100%' }}
                disabled={true}
                options={data.multipleValue}
                fieldNames={{
                  label: 'name',
                  value: 'name',
                  children: 'children',
                }}
                defaultValue={data.inputValue}
                placeholder="请选择"
              />
            </div>
          )
        } else {
          return (
            <Radio.Group
              disabled={true}
              value={data.inputValue[0]}
              className={[`${styles.choiceField}`, `${styles.readOnly}`].join(
                ' '
              )}
            >
              {data.multipleValue.map((item, index) => (
                <div
                  key={index}
                  className={styles.choiceFieldItem}
                  style={{ width: 100 / data.showType + '%' }}
                >
                  <Radio
                    value={item.name}
                    defaultChecked={index == 1}
                    style={{ whiteSpace: 'normal', wordWrap: 'break-word' }}
                  >
                    {item.name}
                  </Radio>
                </div>
              ))}
            </Radio.Group>
          )
        }
      default:
        return <span>无法识别</span>
    }
  }

  renderActionButton() {
    if (!this.state.toaDataForm) {
      return <span></span>
    }
    let actionGroupView = ''
    switch (this.state.toaDataForm.status) {
      case -1:
        actionGroupView = (
          <div className={styles.flexItem}>
            <div
              className={styles.commentBtnAdd}
              onClick={() => {
                this.showChatBox()
              }}
            >
              <input
                readOnly={true}
                type="text"
                placeholder="评论一句吧"
                className={styles.commentChat_input}
              ></input>
            </div>
          </div>
        )
        break
      case 0:
        if (this.state.isCreator) {
          actionGroupView = (
            <div className={styles.flexItem}>
              <div
                className={styles.buttonItem}
                onClick={() =>
                  this.setState({
                    actionType: 0,
                    approveDialogShow: !this.state.approveDialogShow,
                  })
                }
              >
                <div
                  className={[
                    `${styles.buttonItemInner}`,
                    `${styles.btnEnd}`,
                  ].join(' ')}
                >
                  <i
                    className={[
                      `${styles.icon}`,
                      `${styles.icon_aReview_end}`,
                    ].join(' ')}
                  ></i>
                  <span>关闭</span>
                </div>
              </div>
              <div
                className={styles.buttonItem}
                onClick={() =>
                  this.props.history.push({
                    pathname: '/formmain',
                    query: { formDataId: this.state.formDataId },
                  })
                }
              >
                <div className={styles.buttonItemInner}>
                  <i
                    className={[
                      `${styles.icon}`,
                      `${styles.icon_aReview_edit}`,
                    ].join(' ')}
                  ></i>
                  <span>编辑</span>
                </div>
              </div>
            </div>
          )
        } else {
          actionGroupView = (
            <div className={styles.flexItem}>
              <div
                className={styles.commentBtnAdd}
                onClick={() => {
                  this.showChatBox()
                }}
              >
                <input
                  readOnly={true}
                  type="text"
                  placeholder="评论一句吧"
                  className={styles.commentChat_input}
                ></input>
              </div>
            </div>
          )
        }
        break
      case 1:
        actionGroupView = (
          <div className={styles.flexItem}>
            <div
              className={styles.commentBtnAdd}
              onClick={() => {
                this.showChatBox()
              }}
            >
              <input
                readOnly={true}
                type="text"
                placeholder="评论一句吧"
                className={styles.commentChat_input}
              ></input>
            </div>
          </div>
        )
        break
      case 2:
        if (this.state.isTransactor) {
          actionGroupView = (
            <div className={styles.flexItem}>
              <div
                className={styles.buttonItem}
                onClick={() =>
                  this.setState({
                    actionType: 1,
                    approveDialogShow: !this.state.approveDialogShow,
                  })
                }
              >
                <div
                  className={[
                    `${styles.buttonItemInner}`,
                    `${styles.btnApprove}`,
                  ].join(' ')}
                >
                  <i
                    className={[
                      `${styles.icon}`,
                      `${styles.icon_aReview_ok}`,
                    ].join(' ')}
                  ></i>
                  <span className={styles.text}>审批</span>
                </div>
              </div>
              {this.state.currentNode.nodeConfig.isBack ? (
                <div
                  className={styles.buttonItem}
                  onClick={() =>
                    this.setState({
                      actionType: 2,
                      approveDialogShow: !this.state.approveDialogShow,
                    })
                  }
                >
                  <div
                    className={[
                      `${styles.buttonItemInner}`,
                      `${styles.btnEnd}`,
                    ].join(' ')}
                  >
                    <i
                      className={[
                        `${styles.icon}`,
                        `${styles.icon_aReview_no}`,
                      ].join(' ')}
                    ></i>
                    <span className={styles.text}>退审</span>
                  </div>
                </div>
              ) : (
                ''
              )}
              {this.state.currentNode.nodeConfig.isAddCountersign ? (
                <div
                  className={styles.buttonItem}
                  onClick={() =>
                    this.setState({
                      actionType: 3,
                      approveDialogShow: !this.state.approveDialogShow,
                    })
                  }
                >
                  <div
                    className={[
                      `${styles.buttonItemInner}`,
                      `${styles.btnAdd}`,
                    ].join(' ')}
                  >
                    <i
                      className={[
                        `${styles.icon}`,
                        `${styles.icon_aReview_add}`,
                      ].join(' ')}
                    ></i>
                    <span className={styles.text}>加签</span>
                  </div>
                </div>
              ) : (
                ''
              )}
            </div>
          )
        } else if (this.state.isCreator) {
          actionGroupView = (
            <div className={styles.flexItem}>
              {this.state.currentNode.nodeConfig.isClose ? (
                <div
                  className={styles.buttonItem}
                  onClick={() =>
                    this.setState({
                      actionType: 0,
                      approveDialogShow: !this.state.approveDialogShow,
                    })
                  }
                >
                  <div
                    className={[
                      `${styles.buttonItemInner}`,
                      `${styles.btnEnd}`,
                    ].join(' ')}
                  >
                    <i
                      className={[
                        `${styles.icon}`,
                        `${styles.icon_aReview_end}`,
                      ].join(' ')}
                    ></i>
                    <span>关闭</span>
                  </div>
                </div>
              ) : (
                ''
              )}
              {this.state.toaDataFormLogs.length === 1 ? (
                <div
                  className={styles.buttonItem}
                  onClick={() => this.undoFormData()}
                >
                  <div className={styles.buttonItemInner}>
                    <i
                      className={[
                        `${styles.icon}`,
                        `${styles.icon_aReview_undo}`,
                      ].join(' ')}
                    ></i>
                    <span>撤回</span>
                  </div>
                </div>
              ) : (
                ''
              )}
              {this.state.toaDataFormLogs.length !== 1 &&
              !this.state.currentNode.nodeConfig.isClose ? (
                <div
                  className={styles.commentBtnAdd}
                  onClick={() => {
                    this.showChatBox()
                  }}
                >
                  <input
                    readOnly={true}
                    type="text"
                    placeholder="评论一句吧"
                    className={styles.commentChat_input}
                  ></input>
                </div>
              ) : (
                ''
              )}
            </div>
          )
        } else if (this.state.currentNode.preCountersign) {
          actionGroupView = (
            <div className={styles.flexItem}>
              {this.state.currentNode.preCountersign ? (
                <div
                  className={styles.buttonItem}
                  onClick={() =>
                    this.setState({
                      actionType: 4,
                      approveDialogShow: !this.state.approveDialogShow,
                    })
                  }
                >
                  <div
                    className={[
                      `${styles.buttonItemInner}`,
                      `${styles.btnAdd}`,
                    ].join(' ')}
                  >
                    <i
                      className={[
                        `${styles.icon}`,
                        `${styles.icon_aReview_add}`,
                      ].join(' ')}
                    ></i>
                    <span className={styles.text}>加签</span>
                  </div>
                </div>
              ) : (
                ''
              )}
            </div>
          )
        } else {
          actionGroupView = (
            <div className={styles.flexItem}>
              <div
                className={styles.commentBtnAdd}
                onClick={() => {
                  this.showChatBox()
                }}
              >
                <input
                  readOnly={true}
                  type="text"
                  placeholder="评论一句吧"
                  className={styles.commentChat_input}
                ></input>
              </div>
            </div>
          )
        }
        break
      default:
        actionGroupView = (
          <div className={styles.flexItem}>
            <div
              className={styles.commentBtnAdd}
              onClick={() => {
                this.showChatBox()
              }}
            >
              <input
                readOnly={true}
                type="text"
                placeholder="评论一句吧"
                className={styles.commentChat_input}
              ></input>
            </div>
          </div>
        )
    }

    return (
      <div className={styles.actionButton}>
        {actionGroupView}
        <div
          className={[`${styles.moreButton}`, `${styles.border}`].join(' ')}
          onClick={this.showActionSheet}
        >
          <span>更多</span>
        </div>
      </div>
    )
  }

  renderFileListView(fileList) {
    if (fileList && fileList.length > 0) {
      return (
        <div className={styles.uploadBox}>
          {fileList.map((item) => {
            return (
              <ul>
                {isQiyeweixinApp() ? (
                  <li className={styles.uploadListItem}>
                    <a className={styles.uploadListItemThumbnail}>
                      <img
                        src={this.getThumbUrl(item)}
                        className={styles.img}
                        onClick={() => {
                          if (
                            item &&
                            item.type &&
                            item.type.indexOf('image/') === 0
                          ) {
                            Zmage.browsing({
                              src: ALI_OSS_DOWNLOAD + item.url,
                              backdrop: 'rgba(0,0,0,.5)',
                            })
                          }
                        }}
                      />
                    </a>
                    <a
                      className={styles.uploadListItemName}
                      target="_blank"
                      href={ALI_OSS_DOWNLOAD + item.url}
                      download={item.name}
                    >
                      <span className={styles.uploadListItemTitle}>
                        {item.name}
                      </span>
                      <span className={styles.uploadListItemSize}>
                        {item.size < 100
                          ? item.size.toFixed(0) + ' bytes'
                          : item.size < 102400
                          ? (item.size / 1024).toFixed(2) + ' K'
                          : (item.size / (1024 * 1024)).toFixed(2) + ' M'}
                      </span>
                    </a>
                  </li>
                ) : (
                  <li className={styles.uploadListItem}>
                    <a className={styles.uploadListItemThumbnail}>
                      <img
                        src={this.getThumbUrl(item)}
                        className={styles.img}
                        onClick={() => {
                          if (
                            item &&
                            item.type &&
                            item.type.indexOf('image/') === 0
                          ) {
                            Zmage.browsing({
                              src: ALI_OSS_DOWNLOAD + item.url,
                              backdrop: 'rgba(0,0,0,.5)',
                            })
                          }
                        }}
                      />
                    </a>
                    <div
                      className={styles.uploadListItemName}
                      onClick={() => {
                        if (
                          item &&
                          item.type &&
                          item.type.indexOf('image/') === 0
                        ) {
                          Zmage.browsing({
                            src: ALI_OSS_DOWNLOAD + item.url,
                            backdrop: 'rgba(0,0,0,.5)',
                          })
                        } else {
                          previewFileByOW365(item)
                        }
                      }}
                    >
                      <span className={styles.uploadListItemTitle}>
                        {item.name}
                      </span>
                      <span className={styles.uploadListItemSize}>
                        {item.size < 100
                          ? item.size.toFixed(0) + ' bytes'
                          : item.size < 102400
                          ? (item.size / 1024).toFixed(2) + ' K'
                          : (item.size / (1024 * 1024)).toFixed(2) + ' M'}
                      </span>
                    </div>
                    <a
                      className={styles.uploadListItemIcon}
                      target="_blank"
                      href={
                        process.env.API_HOST +
                        _getDownloadPath(item.url, item.name)
                      }
                      download={item.name}
                    >
                      <i className={styles.downIcon}></i>
                    </a>
                  </li>
                )}
              </ul>
            )
          })}
        </div>
      )
    } else {
      return ''
    }
  }

  renderFormDataLogTime(data) {
    if (data.type !== 3 || data.opAction !== '评论') {
      return (
        <span className={styles.commentListItem_info_time}>
          {moment(data.opTime).format('YYYY年MM月DD日 HH:mm:ss')}
        </span>
      )
    }
    if (this.state.currentUser !== data.opUser) {
      return (
        <span className={styles.commentListItem_info_time}>
          {moment(data.opTime).format('YYYY年MM月DD日 HH:mm:ss')}
        </span>
      )
    }
    if (moment(new Date()).valueOf() - data.opTime <= 60 * 1000) {
      return (
        <span>
          <span className={styles.commentListItem_info_time}>刚刚</span>
          <span
            className={styles.commentListItem_info_delete}
            onClick={(e) => {
              e.preventDefault()
              alert('删除', '是否要删除', [
                { text: '取消', onPress: () => console.log('cancel') },
                { text: '删除', onPress: () => this.dropComment(data.id) },
              ])
            }}
          >
            删除
          </span>
        </span>
      )
    } else if (moment(new Date()).valueOf() - data.opTime <= 60 * 1000 * 30) {
      return (
        <span>
          <span className={styles.commentListItem_info_time}>
            {((moment(new Date()).valueOf() - data.opTime) / 30000).toFixed(0)}
            分钟前
          </span>
          <span
            className={styles.commentListItem_info_delete}
            onClick={(e) => {
              e.preventDefault()
              alert('删除', '是否要删除', [
                { text: '取消', onPress: () => console.log('cancel') },
                { text: '删除', onPress: () => this.dropComment(data.id) },
              ])
            }}
          >
            删除
          </span>
        </span>
      )
    } else {
      return (
        <span className={styles.commentListItem_info_time}>
          {moment(data.opTime).format('YYYY年MM月DD日 HH:mm:ss')}
        </span>
      )
    }
  }

  renderFormDataLogsView() {
    return this.state.toaDataFormLogs.map((item, index) =>
      this.state.onlyShowComments ? (
        <span key={index}>
          {item.type !== 2 && item.type !== 3 && item.type !== 4 ? (
            ''
          ) : (
            <div className={styles.commentListItem}>
              <div className={styles.commentListItemHeader}>
                <img id={item.avatar} src={item.avatar} />
              </div>
              <div className={styles.commentListItemContent}>
                <div className={styles.commentListItemContent_name}>
                  {item.opUserName}
                </div>
                <div className={styles.commentListItem_part}>
                  <p className={styles.commentListItem_part_word}>
                    {item.flowNodeName === '填写表单' ? (
                      <span>已{item.opAction}</span>
                    ) : item.type === 2 ? (
                      <span>
                        已{item.opAction}·【{item.flowNodeName}】，
                        {item.opAction}意见：{item.opDesc}
                      </span>
                    ) : item.type === 3 ? (
                      <div
                        contentEditable={false}
                        dangerouslySetInnerHTML={{ __html: item.opDesc }}
                      ></div>
                    ) : item.type === 4 ? (
                      <span>
                        {item.opDesc} · {item.opAction}
                      </span>
                    ) : (
                      ''
                    )}
                  </p>
                </div>
                {item.type === 3 &&
                item.expand &&
                item.expand.commentImage &&
                item.expand.commentImage.length > 0 ? (
                  <div styles={{ maxWidth: 253 }}>
                    <div className={styles.commentListPictureItem}>
                      {isQiyeweixinApp() ? (
                        <img
                          className={styles.commentListPictureImage}
                          src={
                            process.env.API_HOST +
                            _getDownloadPath(
                              item.expand.commentImage[0].url,
                              item.expand.commentImage[0].name
                            )
                          }
                          onClick={() =>
                            this.previewImage([], item.expand.commentImage[0])
                          }
                        ></img>
                      ) : (
                        <Zmage
                          className={styles.commentListPictureImage}
                          backdrop="rgba(0,0,0,.5)"
                          src={
                            ALI_OSS_DOWNLOAD + item.expand.commentImage[0].url
                          }
                        ></Zmage>
                      )}
                    </div>
                  </div>
                ) : (
                  ''
                )}
                {item.type === 3 &&
                item.expand &&
                item.expand.commentFile &&
                item.expand.commentFile.length > 0
                  ? this.renderFileListView(item.expand.commentFile)
                  : ''}
                <div className={styles.commentListItem_info}>
                  <div className={styles.commentListItem_info_box}>
                    {this.renderFormDataLogTime(item)}
                  </div>
                </div>
              </div>
            </div>
          )}
        </span>
      ) : (
        <div key={index} className={styles.commentListItem}>
          <div className={styles.commentListItemHeader}>
            <img id={item.avatar} src={item.avatar} />
          </div>
          <div className={styles.commentListItemContent}>
            <div className={styles.commentListItemContent_name}>
              {item.opUserName}
            </div>
            <div className={styles.commentListItem_part}>
              <p className={styles.commentListItem_part_word}>
                {item.flowNodeName === '填写表单' ? (
                  <span>已{item.opAction}</span>
                ) : item.type === 2 ? (
                  <span>
                    已{item.opAction}·【{item.flowNodeName}】，{item.opAction}
                    意见：{item.opDesc}
                  </span>
                ) : item.type === 3 ? (
                  <div
                    contentEditable={false}
                    dangerouslySetInnerHTML={{ __html: item.opDesc }}
                  ></div>
                ) : item.type === 4 ? (
                  <span>
                    {item.opDesc} · {item.opAction}
                  </span>
                ) : (
                  <div
                    style={{ backgroundPosition: '-106px 0' }}
                    className={[
                      `${styles.meeting_icon}`,
                      `${styles.icon_icon7}`,
                    ].join(' ')}
                  ></div>
                )}
              </p>
            </div>
            {item.type === 3 &&
            item.expand &&
            item.expand.commentImage &&
            item.expand.commentImage.length > 0 ? (
              <div styles={{ maxWidth: 253 }}>
                <div className={styles.commentListPictureItem}>
                  {isQiyeweixinApp() ? (
                    <img
                      className={styles.commentListPictureImage}
                      src={
                        process.env.API_HOST +
                        _getDownloadPath(
                          item.expand.commentImage[0].url,
                          item.expand.commentImage[0].name
                        )
                      }
                      onClick={() =>
                        this.previewImage([], item.expand.commentImage[0])
                      }
                    ></img>
                  ) : (
                    <Zmage
                      className={styles.commentListPictureImage}
                      backdrop="rgba(0,0,0,.5)"
                      src={ALI_OSS_DOWNLOAD + item.expand.commentImage[0].url}
                    ></Zmage>
                  )}
                </div>
              </div>
            ) : (
              ''
            )}
            {item.type === 3 &&
            item.expand &&
            item.expand.commentFile &&
            item.expand.commentFile.length > 0
              ? this.renderFileListView(item.expand.commentFile)
              : ''}
            <div className={styles.commentListItem_info}>
              <div className={styles.commentListItem_info_box}>
                {this.renderFormDataLogTime(item)}
              </div>
            </div>
          </div>
        </div>
      )
    )
  }

  renderUserSelectChargeView() {
    if (!this.state.toaDataForm) {
      return ''
    }
    let userSelectChargeView = <span></span>
    if (
      this.state.toaDataForm.status === -1 ||
      this.state.toaDataForm.status === 0 ||
      this.state.toaDataForm.status === 1 ||
      this.state.toaDataForm.status === 99
    ) {
      userSelectChargeView = (
        <div className={styles.user_select_charge_view}>
          <div className={styles.userSelectTop}>
            <div className={styles.userCellView}>
              <p className={styles.title}>审批人</p>
            </div>
          </div>
          <div className={styles.userSelectWap}>
            <div className={styles.userSelectListView}>
              {this.state.transactor
                ? this.state.transactor.map((item, index) => (
                    <div key={index} className={styles.userContentWrap}>
                      <div className={styles.userSelectView}>
                        <p className={styles.img}>
                          <img
                            className={styles.user_select_img}
                            src={item.avatar}
                          ></img>
                        </p>
                        <p className={styles.userInfo_name}>{item.name}</p>
                      </div>
                    </div>
                  ))
                : ''}
            </div>
          </div>
        </div>
      )
    } else if (this.state.toaDataForm.status === 2) {
      userSelectChargeView = (
        <span>
          {this.state.currentNodes.map((item, i) => (
            <div className={styles.user_select_charge_view}>
              <div className={styles.userSelectTop}>
                <div className={styles.userCellView}>
                  <p className={styles.title}>
                    当前节点 · {item.flowNodeName}{' '}
                    {item.flowNodeSubName ? (
                      <span style={{ color: '#ff884d', fontWeight: 'bolder' }}>
                        {' '}
                        · {item.flowNodeSubName}
                      </span>
                    ) : (
                      ''
                    )}
                  </p>
                </div>
                <div
                  className={styles.userCellFr}
                  style={{ display: 'none' }}
                ></div>
              </div>
              <div className={styles.userSelectWap}>
                <div className={styles.userSelectListView}>
                  {item.users
                    ? item.users.map((item, index) => (
                        <div key={index} className={styles.userContentWrap}>
                          <div className={styles.userSelectView}>
                            <p className={styles.img}>
                              <img
                                className={styles.user_select_img}
                                src={item.avatar}
                              ></img>
                            </p>
                            <p className={styles.userInfo_name}>{item.name}</p>
                          </div>
                        </div>
                      ))
                    : ''}
                </div>
              </div>
            </div>
          ))}
          {this.state.nextFlowNodes.length &&
          this.state.currentNodes.length <= 1 > 0 ? (
            <div className={styles.user_select_charge_view}>
              <div className={styles.userSelectTop}>
                <div className={styles.userCellView}>
                  <p className={styles.title}>
                    下一节点 · {this.state.nextFlowNodes[0].flowNodeName}{' '}
                    {this.state.nextFlowNodes[0].flowNodeSubName ? (
                      <span style={{ color: '#ff884d', fontWeight: 'bolder' }}>
                        {' '}
                        · {this.state.nextFlowNodes[0].flowNodeSubName}
                      </span>
                    ) : (
                      ''
                    )}
                  </p>
                </div>
                <div
                  className={styles.userCellFr}
                  style={{ display: 'none' }}
                ></div>
              </div>
              <div className={styles.userSelectWap}>
                <div className={styles.userSelectListView}>
                  {this.state.nextFlowNodes[0].users
                    ? this.state.nextFlowNodes[0].users.map((item, index) => (
                        <div key={index} className={styles.userContentWrap}>
                          <div className={styles.userSelectView}>
                            <p className={styles.img}>
                              <img
                                className={styles.user_select_img}
                                src={item.avatar}
                              ></img>
                            </p>
                            <p className={styles.userInfo_name}>{item.name}</p>
                          </div>
                        </div>
                      ))
                    : ''}
                </div>
              </div>
            </div>
          ) : (
            ''
          )}
        </span>
      )
    }

    return (
      <span>
        {userSelectChargeView}
        {this.state.transactorCC && this.state.transactorCC.length > 0 ? (
          <div className={styles.user_select_charge_view}>
            <div className={styles.userSelectTop}>
              <div className={styles.userCellView}>
                <p className={styles.title}>相关人</p>
              </div>
              <div
                className={styles.userCellFr}
                style={{ display: 'none' }}
              ></div>
            </div>
            <div className={styles.userSelectWap}>
              <div className={styles.userSelectListView}>
                {this.state.transactorCC.map((item, index) => (
                  <div key={index} className={styles.userContentWrap}>
                    <div className={styles.userSelectView}>
                      <p className={styles.img}>
                        <img
                          className={styles.user_select_img}
                          src={item.avatar}
                        ></img>
                      </p>
                      <p className={styles.userInfo_name}>{item.name}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        ) : (
          ''
        )}
      </span>
    )
  }

  renderProcessListView(data) {
    const itemView = data.map((item, index) => {
      return (
        <div key={index} className={styles.processItem}>
          <div className={styles.title}>
            <i
              className={[
                `${styles.iconStep}`,
                item.status !== 0
                  ? `${styles.active}`
                  : item.current
                  ? `${styles.current}`
                  : '',
              ].join(' ')}
            ></i>
            <div className={styles.name}>
              <p
                className={styles.titleActive}
                style={{
                  textDecoration:
                    item.effective === 1 ? 'none' : 'line-through',
                }}
              >
                {item.flowNodeName}
                {item.flowNodeSubName ? (
                  <span style={{ color: '#ff884d', fontWeight: 'bolder' }}>
                    {' '}
                    · {item.flowNodeSubName}
                  </span>
                ) : (
                  ''
                )}
              </p>
            </div>
            <p className={styles.processNodeTime}>
              {moment(item.createTime).format('MM-DD HH:mm:ss')}
            </p>
          </div>
          {item.type === 1 ? (
            <div className={styles.content}>
              <p className={styles.c333}>
                <span>
                  {item.opUserName} <span className={styles.dot}>·</span>{' '}
                  {item.opAction}
                </span>
              </p>
            </div>
          ) : item.type === 2 ? (
            <div className={styles.content}>
              {item.status !== 0 ? (
                <p>
                  处理人 ：
                  {item.users.map((user, i) => (
                    <span key={i}>
                      {user.name}
                      {i < item.users.length - 1 ? '、' : ''}
                    </span>
                  ))}
                </p>
              ) : (
                ''
              )}
              <p className={styles.c333}>
                {item.status !== 0 ? (
                  <p style={{ width: '100%' }}>
                    <span>
                      {item.opUserName} <span className={styles.dot}>·</span>{' '}
                      {item.opAction}
                    </span>
                    <span
                      style={{ float: 'right' }}
                      className={styles.processNodeTime}
                    >
                      {moment(item.opTime).format('MM-DD HH:mm:ss')}
                    </span>
                  </p>
                ) : (
                  <p>
                    <span>
                      处理人 ：
                      {item.users.map((user, i) => (
                        <span key={i}>
                          {user.name}
                          {i < item.users.length - 1 ? '、' : ''}
                        </span>
                      ))}
                    </span>
                  </p>
                )}
              </p>
              {item.meddleName ? (
                <p style={{ color: 'black', marginTop: 8 }}>
                  {item.meddleName} · 干预节点
                </p>
              ) : (
                ''
              )}
              {item.status !== 0 ? (
                <p className={styles.processWaitTime}>
                  用时 {_getFormatTimeStr(item.opConsumeTime)}
                </p>
              ) : item.current &&
                this.state.toaDataForm.status !== -1 &&
                this.state.toaDataForm.status !== 99 &&
                item.effective === 1 ? (
                <p className={styles.processWaitTime}>
                  等待{' '}
                  {_getFormatTimeStr(
                    moment(new Date()).valueOf() - item.createTime
                  )}
                </p>
              ) : (
                ''
              )}
            </div>
          ) : item.type === 3 ? (
            <div className={styles.content}>
              {item.subProcessList.map((subList, i) => (
                <div key={i}>
                  <div className={styles.parallelList}>
                    {subList.map((subItem, j) => (
                      <div key={j} className={styles.processItem}>
                        <div className={styles.title}>
                          <i
                            className={[
                              `${styles.iconStep}`,
                              subItem.status !== 0
                                ? `${styles.active}`
                                : subItem.current
                                ? `${styles.current}`
                                : '',
                            ].join(' ')}
                          ></i>
                          <div className={styles.name}>
                            <p
                              className={styles.title}
                              style={{
                                textDecoration:
                                  subItem.effective === 1
                                    ? 'none'
                                    : 'line-through',
                              }}
                            >
                              {subItem.flowNodeName}
                              {subItem.flowNodeSubName ? (
                                <span
                                  style={{
                                    color: '#ff884d',
                                    fontWeight: 'bolder',
                                  }}
                                >
                                  {' '}
                                  · {subItem.flowNodeSubName}
                                </span>
                              ) : (
                                ''
                              )}
                            </p>
                          </div>
                          <p className={styles.processNodeTime}>
                            {moment(subItem.createTime).format(
                              'MM-DD HH:mm:ss'
                            )}
                          </p>
                        </div>
                        <div
                          className={[
                            `${styles.content}`,
                            `${styles.parallelContent}`,
                          ].join(' ')}
                        >
                          {subItem.type === 2 ? (
                            <span>
                              {subItem.status !== 0 ? (
                                <span>
                                  <span>
                                    {subItem.opUserName}{' '}
                                    <span className={styles.dot}>·</span>{' '}
                                    {subItem.opAction}
                                  </span>
                                  <span
                                    style={{ float: 'right', paddingRight: 0 }}
                                    className={styles.processNodeTime}
                                  >
                                    {moment(subItem.opTime).format(
                                      'MM-DD HH:mm:ss'
                                    )}
                                  </span>
                                  <p className={styles.processWaitTime}>
                                    用时{' '}
                                    {_getFormatTimeStr(subItem.opConsumeTime)}
                                  </p>
                                </span>
                              ) : (
                                <span>
                                  <p>
                                    处理人：
                                    {subItem.users.map((user, i) => (
                                      <span key={i}>
                                        {user.name}
                                        {i < subItem.users.length - 1
                                          ? '、'
                                          : ''}
                                      </span>
                                    ))}
                                  </p>
                                  {subItem.current &&
                                  this.state.toaDataForm.status !== -1 &&
                                  this.state.toaDataForm.status !== 99 &&
                                  subItem.effective === 1 ? (
                                    <p className={styles.processWaitTime}>
                                      等待{' '}
                                      {_getFormatTimeStr(
                                        moment(new Date()).valueOf() -
                                          subItem.createTime
                                      )}
                                    </p>
                                  ) : (
                                    ''
                                  )}
                                </span>
                              )}
                            </span>
                          ) : subItem.type === 5 ? (
                            <span>
                              <p>处理人/会签 ：{subItem.opUserName}</p>
                              {subItem.countersignList &&
                              subItem.countersignList.length > 0 ? (
                                <span>
                                  {subItem.countersignList.map(
                                    (subChild, j) => {
                                      return (
                                        <p className={styles.c333}>
                                          <span>
                                            {subChild.opUserName}{' '}
                                            <span className={styles.dot}>
                                              ·
                                            </span>{' '}
                                            {subChild.opAction}
                                          </span>
                                          <span
                                            style={{
                                              float: 'right',
                                              paddingRight: 0,
                                            }}
                                            className={styles.processNodeTime}
                                          >
                                            {moment(subChild.opTime).format(
                                              'MM-DD HH:mm:ss'
                                            )}
                                          </span>
                                        </p>
                                      )
                                    }
                                  )}
                                </span>
                              ) : (
                                ''
                              )}
                              {subItem.status === 0 &&
                              subItem.current &&
                              subItem.effective === 1 ? (
                                <p className={styles.processWaitTime}>
                                  等待{' '}
                                  {_getFormatTimeStr(
                                    moment(new Date()).valueOf() -
                                      subItem.createTime
                                  )}
                                </p>
                              ) : subItem.status !== 0 &&
                                this.state.toaDataForm.status !== -1 &&
                                this.state.toaDataForm.status !== 99 ? (
                                <p className={styles.processWaitTime}>
                                  用时{' '}
                                  {_getFormatTimeStr(subItem.opConsumeTime)}
                                </p>
                              ) : (
                                ''
                              )}
                            </span>
                          ) : (
                            ''
                          )}
                          {subItem.meddleName ? (
                            <span>
                              <p style={{ color: 'black', marginTop: 8 }}>
                                {subItem.meddleName} · 干预节点
                              </p>
                            </span>
                          ) : (
                            ''
                          )}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          ) : item.type === 5 ? (
            <div className={styles.content}>
              <p>处理人/会签 ：{item.opUserName}</p>
              {item.countersignList && item.countersignList.length > 0 ? (
                <span>
                  {item.countersignList.map((subItem, j) => {
                    return (
                      <p className={styles.c333}>
                        <span>
                          {subItem.opUserName}{' '}
                          <span className={styles.dot}>·</span>{' '}
                          {subItem.opAction}
                        </span>
                        <span
                          style={{ float: 'right', marginRight: -5 }}
                          className={styles.processNodeTime}
                        >
                          {moment(subItem.opTime).format('MM-DD HH:mm:ss')}
                        </span>
                      </p>
                    )
                  })}
                </span>
              ) : (
                ''
              )}
              {item.meddleName ? (
                <p style={{ marginTop: 8 }}>{item.meddleName} · 干预节点</p>
              ) : (
                ''
              )}
              {item.status !== 0 ? (
                <p className={styles.processWaitTime}>
                  用时 {_getFormatTimeStr(item.opConsumeTime)}
                </p>
              ) : this.state.toaDataForm.status !== -1 &&
                this.state.toaDataForm.status !== 99 ? (
                <p className={styles.processWaitTime}>
                  等待{' '}
                  {_getFormatTimeStr(
                    moment(new Date()).valueOf() - item.createTime
                  )}
                </p>
              ) : (
                ''
              )}
            </div>
          ) : (
            ''
          )}
        </div>
      )
    })

    return <span>{itemView}</span>
  }

  render() {
    if (this.state.hasError) {
      return <h1>出错了...</h1>
    }
    return (
      <div className="wrap">
        {this.state.isLoading ? (
          <span>
            <Spin
              tip={'享受生活，享受阳光'}
              style={{ width: '100%', marginTop: '40%' }}
              size="large"
            />
            <Modal
              visible={this.state.tipModal}
              transparent
              maskClosable={false}
              title="提示"
              footer={[
                { text: '确定', onPress: () => this.props.history.push('/') },
              ]}
            >
              <div style={{ height: 25 }}>此工单信息已被删除</div>
            </Modal>
          </span>
        ) : this.state.currentNodes.length > 1 && !this.state.currentNode.id ? (
          <div className={[`${styles.mask_body}`, `${styles.top}`].join(' ')}>
            <div className={styles.flow_selectNode_box}>
              <div className={styles.flow_selectNode_item}>
                <ul>
                  <li>
                    <div className={styles.list_item}>
                      <div className={styles.list_item_box}>
                        <p className={styles.person_headPic}>
                          <img
                            className={[
                              `${styles.img}`,
                              `${styles.borderRadius}`,
                            ].join(' ')}
                            src={this.state.profile.avatar}
                          />
                        </p>
                        <div className={styles.list_content_box}>
                          <div className={styles.list_item_user}>
                            <span className={styles.list_user_name}>
                              {this.state.profile.name}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                </ul>
                <p className={styles.flow_selectNode_title}>
                  请选择可处理的节点
                </p>
                <div className={styles.choose_node_list}>
                  <ul>
                    {this.state.currentNodes.map((item, index) => (
                      <li
                        onClick={() => {
                          this.getNextFlowNodes(item.id)
                          this.setState({ currentNode: item })
                        }}
                        key={index}
                        style={{ height: 45, lineHeight: '25px' }}
                        className={styles.flowNodeList_select}
                      >
                        <p className={styles.nodeName}>
                          {item.flowNodeName}
                          {item.flowNodeSubName ? (
                            <span
                              style={{ color: '#ff884d', fontWeight: 'bolder' }}
                            >
                              {' '}
                              · {item.flowNodeSubName}
                            </span>
                          ) : (
                            ''
                          )}
                        </p>
                        <span className={styles.icon_arrow_right}></span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <Drawer
            className="my-drawer"
            style={{
              display: 'contents',
              minHeight: document.documentElement.clientHeight,
              width: this.state.fullScreenChild ? 'auto' : '',
            }}
            sidebar={this.renderChildFormDetail()}
            position="right"
            touch={false}
            contentStyle={{ width: this.state.fullScreenChild ? 'auto' : '' }}
            open={this.state.childFormDrawerOpen}
          >
            <div
              ref={(ref) => {
                this.titleBox = ref
              }}
              className={styles.formTitleBox}
            >
              <div className={styles.formTitleRead}>
                <span className={styles.ctitle}>
                  {this.state.toaForm.formTitle}
                </span>
                <CopyToClipboard
                  text={this.state.toaForm.formTitle}
                  onCopy={() => {
                    Toast.info('标题复制成功', 1)
                  }}
                >
                  <CopyTwoTone style={{ fontSize: 20, margin: 8 }} />
                </CopyToClipboard>
                {this.renderFormStatus()}
              </div>
              <div className={styles.formTitleMsg}>
                {this.state.toaDataForm ? (
                  <span>
                    <span className={styles.formTitleSpan}>
                      {moment(this.state.toaDataForm.createTime).format(
                        'YYYY-MM-DD HH:mm:ss'
                      )}
                    </span>
                    <span
                      className={[
                        `${styles.formTitleSpan}`,
                        `${styles.colorblue}`,
                      ].join(' ')}
                    >
                      {this.state.toaDataForm.createUserName}
                    </span>
                    <Link
                      to={{
                        pathname: '/formprint',
                        query: {
                          formDataId: this.state.toaDataForm.formDataId,
                        },
                      }}
                    >
                      <span
                        className={styles.colorblue}
                        style={{ cursor: 'pointer' }}
                      >
                        打印预览
                      </span>
                    </Link>
                  </span>
                ) : (
                  ''
                )}
              </div>
            </div>
            <div className={styles.wrap} style={{ top: this.state.mTop }}>
              <div className={styles.formBg}>
                <div className={styles.formDetailBox}>
                  <div
                    className={styles.formDetailContent}
                    style={{
                      minHeight: 92,
                      height: this.state.formDetailShow ? 'auto' : '92px',
                    }}
                  >
                    <p
                      style={{ wordWrap: 'break-word' }}
                      dangerouslySetInnerHTML={{
                        __html: this.state.toaForm.formDesc,
                      }}
                    ></p>
                  </div>
                  <div className={styles.formDetailContentBlur}></div>
                  <div
                    className={styles.formDetailContentToggle}
                    onClick={this.formDetailToggle}
                  >
                    {this.state.formDetailShow ? '收起' : '展开显示全部'}
                    <span className={styles.toggleDown}></span>
                  </div>
                </div>
              </div>
              <Form className={styles.formContent} ref={this.mainFormRef}>
                {this.state.formFields.map((item) =>
                  item.isVisible ? (
                    <div className={styles.formGroup} key={item.fieldId}>
                      {item.fieldType != 'SectionBreak' ? (
                        <div className={styles.formLabel}>
                          <label className={styles.controlLabel}>
                            {item.fieldTitle}
                            {item.fieldType != 'StaffField' &&
                            item.fieldType != 'ChildField' &&
                            item.fieldType != 'AccessoryField' &&
                            item.fieldType != 'FORMREFCustomerField' &&
                            item.fieldType != 'OcrInvoice' &&
                            item.fieldType != 'ImageField' ? (
                              <CopyToClipboard
                                text={
                                  item.inputValue.length > 0
                                    ? item.inputValue[0]
                                    : ''
                                }
                                onCopy={() => {
                                  Toast.info(item.fieldTitle + '值复制成功', 1)
                                }}
                              >
                                <CopyTwoTone
                                  style={{ fontSize: 18, padding: '0px 10px' }}
                                />
                              </CopyToClipboard>
                            ) : (
                              <div></div>
                            )}
                          </label>
                        </div>
                      ) : (
                        ''
                      )}
                      <div className={styles.fieldContent}>
                        <div
                          className={
                            this.state.fullScreenChild == item.fieldId
                              ? `${styles.childFormFullScreen}`
                              : ``
                          }
                        >
                          {this.renderFormField(item)}
                        </div>
                      </div>
                      <div className={styles.helpBlock}></div>
                    </div>
                  ) : (
                    ''
                  )
                )}
              </Form>
              {this.state.nodeExFieldList &&
              this.state.nodeExFieldList.length > 0 ? (
                <div
                  className={styles.circulationDetails}
                  style={{ position: 'relative' }}
                >
                  <span
                    className={styles.serial_entrance}
                    onClick={() =>
                      this.setState({
                        nodeExFieldListShow: !this.state.nodeExFieldListShow,
                      })
                    }
                  >
                    <i className={styles.icon_serial}></i>
                    {this.state.nodeExFieldListShow ? '收起' : '展开'}
                  </span>
                  <div className={styles.user_select_charge_view}>
                    <div className={styles.userSelectTop}>
                      <div className={styles.userCellView}>
                        <p className={styles.title}>审批字段</p>
                      </div>
                    </div>

                    {this.state.nodeExFieldListShow
                      ? this.state.nodeExFieldList.map((item) => (
                          <div className={styles.formGroup} key={item.fieldId}>
                            {item.fieldType != 'SectionBreak' ? (
                              <div className={styles.formLabel}>
                                <label className={styles.controlLabel}>
                                  {item.fieldTitle}
                                </label>
                              </div>
                            ) : (
                              ''
                            )}
                            <div className={styles.fieldContent}>
                              {this.renderFormField(item)}
                            </div>
                            <div className={styles.helpBlock}></div>
                          </div>
                        ))
                      : ''}
                  </div>
                </div>
              ) : (
                ''
              )}
              <div
                className={styles.circulationDetails}
                style={{ position: 'relative' }}
              >
                <span
                  className={styles.serial_entrance}
                  onClick={() =>
                    this.setState({
                      processPopShow: !this.state.processPopShow,
                    })
                  }
                >
                  <i className={styles.icon_serial}></i>流转明细
                </span>
                {this.renderUserSelectChargeView()}
              </div>
              {this.state.toaDataFormLogs.length > 0 ? (
                <div>
                  <div style={{ marginTop: 10 }}></div>
                  <div className={styles.commentHeader}>
                    <div className={styles.commentHeaderBox}>
                      <span className={styles.commentHeaderTitle}>评论</span>
                      <p className={styles.commentHeaderCount}>
                        {this.state.formLogsLength}
                      </p>
                    </div>
                    <div className={styles.commentCell}>
                      只看评论
                      <Switch
                        style={{ marginLeft: 10 }}
                        checked={this.state.onlyShowComments}
                        onChange={(value) => {
                          let newLength = 0
                          if (value) {
                            this.state.toaDataFormLogs.map((item, index) =>
                              item.type != 1 ? ++newLength : ''
                            )
                          } else {
                            newLength = this.state.toaDataFormLogs.length
                          }
                          newLength--

                          this.setState({
                            onlyShowComments: !this.state.onlyShowComments,
                            formLogsLength: newLength,
                          })
                        }}
                      />
                    </div>
                  </div>
                  <div className={styles.commentList}>
                    {this.renderFormDataLogsView()}
                  </div>
                </div>
              ) : (
                <span></span>
              )}
              {this.renderActionButton()}
              {this.state.approveDialogShow ? (
                <ApproveDialog
                  actionType={this.state.actionType}
                  close={() =>
                    this.setState({
                      approveDialogShow: !this.state.approveDialogShow,
                    })
                  }
                  formDataId={this.state.formDataId}
                  currentNode={this.state.currentNode}
                  allowApprovalComments={
                    this.state.currentNode.nodeConfig.allowApprovalComments
                  }
                  submit={this.approveSubmit}
                  exFields={this.state.currentNode.exFields}
                />
              ) : (
                ''
              )}
              {this.state.processPopShow ? (
                <div className={styles.processPop}>
                  <div className={styles.maskLayer}></div>
                  <div className={styles.process}>
                    <div className={styles.processScroll}>
                      <div className={styles.processHead}>
                        <div className={styles.processTitle}>
                          <p>流转明细</p>
                          {this.state.toaDataForm.status === 2 ||
                          this.state.toaDataForm.status === 0 ? (
                            <p className={styles.processAllTime}>
                              用时{' '}
                              {_getFormatTimeStr(
                                moment(new Date()).valueOf() -
                                  this.state.toaDataForm.createTime
                              )}
                            </p>
                          ) : (
                            <p className={styles.processAllTime}>
                              用时{' '}
                              {_getFormatTimeStr(
                                moment(
                                  this.state.toaDataForm.updateTime -
                                    this.state.toaDataForm.createTime
                                )
                              )}
                            </p>
                          )}
                        </div>
                      </div>
                      <div className={styles.processContent}>
                        <div className={styles.processList}>
                          {this.renderProcessListView(this.state.processList)}
                          {this.state.toaDataForm.status === 1 ||
                          this.state.toaDataForm.status === -1 ||
                          this.state.toaDataForm.status === 99 ? (
                            <div className={styles.processItem}>
                              <div className={styles.title}>
                                <i
                                  className={[
                                    `${styles.iconStep}`,
                                    `${styles.active}`,
                                  ].join(' ')}
                                ></i>
                                <div className={styles.name}>
                                  <p className={styles.titleActive}>
                                    {this.state.toaDataForm.status === 99
                                      ? '流程干预 · '
                                      : ''}
                                    结束
                                  </p>
                                </div>
                                <p className={styles.processNodeTime}>
                                  {moment(
                                    this.state.toaDataForm.updateTime
                                  ).format('MM-DD HH:mm:ss')}
                                </p>
                              </div>
                            </div>
                          ) : (
                            <div className={styles.processItem}>
                              <div className={styles.title}>
                                <i className={styles.iconStep}></i>
                                <div className={styles.name}>
                                  <p>流转中</p>
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className={styles.processFooter}>
                      <Button
                        style={{
                          width: '100%',
                          height: 44,
                          background: '#F4F6F8',
                          color: '#7A7D80',
                          fontSize: 18,
                          border: 'none',
                        }}
                        onClick={() =>
                          this.setState({
                            processPopShow: !this.state.processPopShow,
                          })
                        }
                      >
                        返回
                      </Button>
                    </div>
                  </div>
                </div>
              ) : (
                ''
              )}
            </div>
          </Drawer>
        )}
        {this.state.commentChatShow ? (
          <div
            className={[`${styles.maskFixBox}`, `${styles.isNone}`].join(' ')}
          >
            <div
              className={[`${styles.maskFixBg}`, `${styles.modelRgba}`].join(
                ' '
              )}
              onClick={() => this.closeChatBox()}
            ></div>
            <div
              className={[
                `${styles.maskBody}`,
                `${styles.bottom}`,
                `${styles.colorFFF}`,
              ].join(' ')}
            >
              <div className={styles.chatBox}>
                <div className={styles.chatHeaderHeight}></div>
                <div className={styles.chatInputHeader}>
                  <p className={styles.chatTitle}>评论</p>
                  <img
                    src={require('../../assets/img/close.png')}
                    className={styles.chatClose}
                    onClick={() => this.closeChatBox()}
                  />
                </div>
              </div>
              <div className={styles.chatContentBox}>
                <div className={styles.chatInputContent}>
                  <div className={styles.chatInputTextarea}>
                    <div className={styles.textareaBox}>
                      <TextareaItem
                        onBlur={() => window.scrollTo(0, 0)}
                        rows={10}
                        count={1000}
                        placeholder="请输入内容..."
                        className={styles.textarea}
                        value={this.state.commentContent}
                        style={{ height: 180, minHeight: 180 }}
                        autofocus="autofocus"
                        onChange={(value) => {
                          this.setState({ commentContent: value })
                        }}
                      ></TextareaItem>
                    </div>
                  </div>
                </div>
                <div className={styles.uploadContent}>
                  {this.state.commentImage.length === 1 ? (
                    <div className={styles.uploadBox}>
                      <ul className={styles.uploadListPictureCard}>
                        <li className={styles.uploadListItem}>
                          {isQiyeweixinApp() ? (
                            <a
                              className={styles.uploadListItemThumbnail}
                              onClick={() =>
                                this.previewImage(
                                  [],
                                  this.state.commentImage[0]
                                )
                              }
                            >
                              <img
                                className={styles.img}
                                src={
                                  process.env.API_HOST +
                                  _getDownloadPath(
                                    this.state.commentImage[0].url,
                                    this.state.commentImage[0].name
                                  )
                                }
                              ></img>
                            </a>
                          ) : (
                            <a className={styles.uploadListItemThumbnail}>
                              <Zmage
                                className={styles.img}
                                src={
                                  ALI_OSS_DOWNLOAD +
                                  this.state.commentImage[0].url
                                }
                                backdrop="rgba(0,0,0,.5)"
                              ></Zmage>
                            </a>
                          )}
                          <span
                            className={styles.uploadListItemIcon}
                            onClick={() => {
                              this.setState({ commentImage: [] })
                            }}
                          >
                            <i className={styles.removeIcon}></i>
                          </span>
                        </li>
                      </ul>
                    </div>
                  ) : (
                    ''
                  )}
                  {this.state.commentFile.map((item, index) => {
                    return (
                      <div key={index} className={styles.uploadBox}>
                        <ul className={styles.uploadListPictureCard}>
                          <li className={styles.uploadListItem}>
                            <div
                              className={styles.uploadListItemThumbnail}
                              onClick={() => {
                                if (
                                  item &&
                                  item.type &&
                                  item.type.indexOf('image/') === 0
                                ) {
                                  Zmage.browsing({
                                    src: ALI_OSS_DOWNLOAD + item.url,
                                    backdrop: 'rgba(0,0,0,.5)',
                                  })
                                } else {
                                  previewFileByOW365(item)
                                }
                              }}
                            >
                              <img
                                className={styles.img}
                                src={this.getThumbUrl(item)}
                                onClick={() => {
                                  if (
                                    item &&
                                    item.type &&
                                    item.type.indexOf('image/') === 0
                                  ) {
                                    Zmage.browsing({
                                      src: ALI_OSS_DOWNLOAD + item.url,
                                      backdrop: 'rgba(0,0,0,.5)',
                                    })
                                  }
                                }}
                              ></img>
                            </div>
                            <span
                              className={styles.uploadListItemIcon}
                              onClick={() => {
                                this.state.commentFile.splice(index, 1)
                                this.setState({
                                  commentFile: this.state.commentFile,
                                  currentFileList: this.state.commentFile,
                                })
                              }}
                            >
                              <i className={styles.removeIcon}></i>
                            </span>
                          </li>
                        </ul>
                      </div>
                    )
                  })}
                </div>
              </div>
              <div style={{ height: 52, minHeight: 52 }}></div>
              <div
                className={[
                  `${styles.chatInputFooter}`,
                  `${styles.bottom}`,
                ].join(' ')}
              >
                <div className={styles.chatFooterFlex}>
                  <div className={styles.chatTools}>
                    {this.state.formSetting &&
                    this.state.formSetting.submitcfg &&
                    this.state.formSetting.submitcfg.transactorCCEnable ===
                      '0' ? (
                      <span></span>
                    ) : (
                      <div
                        className={styles.chatToolsChild}
                        onClick={(e) => {
                          e.preventDefault()
                          this.setState(
                            {
                              selectedData: [].concat(this.state.atMembers),
                              selectedExtra: {
                                type: 1,
                                commonList: this.state.allUserList,
                              },
                            },
                            () =>
                              setTimeout(this.selectMemberModal.showModal(), 20)
                          )
                        }}
                      >
                        <i
                          className={[
                            `${styles.iconfont}`,
                            `${styles.iconCommentAt}`,
                          ].join(' ')}
                        ></i>
                      </div>
                    )}
                    {this.state.commentImage.length === 0 ? (
                      <span>
                        {isQiyeweixinApp() ? (
                          <div className={styles.chatToolsChild}>
                            <i
                              className={[
                                `${styles.iconfont}`,
                                `${styles.iconCommentImg}`,
                              ].join(' ')}
                              onClick={() => {
                                this.addImageOnClick()
                              }}
                            ></i>
                          </div>
                        ) : (
                          <Upload
                            action={process.env.API_HOST + '/file/upload.api'}
                            onChange={(info) => this.onCommentImageUpload(info)}
                            accept="image/*,.pdf"
                            data={{ authtoken: this.sid }}
                            showUploadList={false}
                            beforeUpload={() => Toast.info('正在上传...', 600)}
                          >
                            <div className={styles.chatToolsChild}>
                              <i
                                className={[
                                  `${styles.iconfont}`,
                                  `${styles.iconCommentImg}`,
                                ].join(' ')}
                              ></i>
                            </div>
                          </Upload>
                        )}
                      </span>
                    ) : (
                      <div
                        className={styles.chatToolsChild}
                        onClick={() => Toast.info('最多只能上传一张图片', 1)}
                      >
                        <i
                          className={[
                            `${styles.iconfont}`,
                            `${styles.iconCommentImg}`,
                          ].join(' ')}
                        ></i>
                      </div>
                    )}
                    {this.state.commentFile.length < 4 ? (
                      <Upload
                        action={process.env.API_HOST + '/file/upload.api'}
                        onChange={(info) => this.onCommentFileUpload(info)}
                        data={{ authtoken: this.sid }}
                        showUploadList={false}
                        fileList={this.state.currentFileList}
                        beforeUpload={() => Toast.info('正在上传...', 600)}
                      >
                        <span className={styles.fileUpload}></span>
                      </Upload>
                    ) : (
                      <span
                        className={styles.fileUpload}
                        onClick={() => Toast.info('最多只能上传四个附件', 1)}
                      ></span>
                    )}
                  </div>
                  <div className={styles.chatButtonBox}>
                    <span
                      className={styles.chatButton}
                      onClick={() => this.submitComment()}
                    >
                      发表
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          ''
        )}
        <SelectMember
          triggerRef={this.bindRef}
          callback={this.updateSelectedData}
          selectedData={this.state.selectedData}
          sid={this.sid}
          extra={this.state.selectedExtra}
        />
        <SelectSourceData
          triggerRef={this.bindSelectSourceDataRef}
          callback={this.updateSelectedData}
          selectedData={this.state.selectedData}
          sid={this.sid}
          extra={this.state.selectedExtra}
        />
      </div>
    )
  }
}

export default withCookies(FormDetailPage)

